
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import store from "@/services/store";
import VueElementLoading from "vue-element-loading";
import axios from "axios";
import { IGu, IKato, IModule } from "../user-management/user-management-int";
import { IBaseModule, INewUsers, IUsers } from "./Administration.vue";
import { ITemplateDetail } from "./admin-sample.vue";

// Интерфейс Order с типом createDate: string
export interface Order {
    id: number | null;
    dictVwOrder: number;
    dictVwOrderId: number;
    dictAppTypeAppId: number;
    userId: string;
    createDate: string; // формат dd.mm.yyyy
    isSaveFile: boolean;
    status: number;
    gu: string;
    guCode: string;
    gkkpCode: string;
    gkkp: string | null;
    kato: string | null;
    headName?: string | null;
    num?: string;
    userNameSupport?: string;
    userIdSupport?: string;
    region: string;
}

// Интерфейс для получения Order с createDate как timestamp
export interface OrderResponse extends Omit<Order, "createDate"> {
    createDate: number; // response from service
    formattedCreateDate?: string;
    statusName?: string;
}

export interface UserList {
    user: IUsers;
    moduleList: any[];
    isExpDropdown: boolean;
    modulesHierarchy?: any[];
    // Модули шаблона-сироты (родитель не входит в шаблон): не отображаются
    // и не редактируются в UI, но должны попасть в заявку при сохранении.
    hiddenModules?: IBaseModule[];
}

export interface SaveOrderRequest {
    order: Order;
    userList: UserList[];
}

export interface RequestResponse {
    order: OrderResponse;
    userList: UserList[];
}

@Component({
    name: "accessRequest",
    components: {
        multiselect: Multiselect,
        loading: VueElementLoading,
    },
})
export default class AccessRequest extends Vue {
    $refs!: {
        drop: HTMLFormElement;
        userCardRef: HTMLFormElement;
        reqFormRef: HTMLFormElement;
        bcRegGu: HTMLFormElement;
        bcRegion: HTMLFormElement;
        bcRegionKgkp: HTMLFormElement;
        bcGu: HTMLFormElement;
        bcGkkp: HTMLFormElement;
        fileInput: HTMLFormElement;
        comModal: HTMLFormElement;
        rightUmContent: HTMLElement;
    };
    private mode: "view" | "edit" | "create" = "view";
    private reqData: RequestResponse = {
        order: {
            id: 0,
            dictVwOrder: 0,
            dictVwOrderId: 0,
            dictAppTypeAppId: 0,
            userId: "",
            createDate: 0,
            isSaveFile: false,
            status: 1,
            gu: "",
            guCode: "",
            gkkp: null,
            gkkpCode: "",
            kato: null,
            headName: "",
            num: "",
            region: "",
        },
        userList: [] as UserList[],
    };

    @Prop({ required: true })
    private isUserSupport!: boolean;
    private showRequestForm: boolean = false;
    private backReqList: boolean = true;
    private typeOrgReq: number = 0;
    private isAdductor: boolean = true;
    private typeAppList: any[] = [];
    private selectedAppType: any = null;
    private categoryAppList: any[] = [];
    private selectedCategApp: any = null;
    private guList: IGu[] = [];
    private gkkpList: any[] = [];
    private adductorGuList: any = [];
    private selectedAdductGu: any = null;
    private selectedRegServer: any = null;
    private serverRegList: any[] = [];
    private regionList: IKato[] = [];
    private selectedRegion: any = null;
    private selectedRegGu: any = null;
    private selectedRegionKgkp: any = null;
    private selectedRegKgkp: any = null;
    private selectedGu: any = null;
    private selectedGkkp: any = null;
    private selectedKgkpGu: any = null;
    private usersList: IUsers[] = [];
    private selectAllReq: boolean = false;
    private searchIIN: string = "";
    private searchName: string = "";
    private searchPhone: string = "";
    private searchEmail: string = "";
    private showComModal = false;
    private showComHistModal = false;
    private showStatusHistModal = false;
    private commentTxt = "";
    private reasonsList: Array<{
        id: number;
        code: string;
        nameKk: string;
        nameRu: string;
        nameEn: string;
    }> = [];
    private commentHistoryList: any[] = [];
    private statusHistoryList: any[] = [];
    private selectedReasonIds: number[] = [];
    // private selectedUser: IUsers | null = null;
    private requestsList: any[] = [];
    private selectedRequest: Order | null = null;
    private modulesList: IBaseModule[] = [];
    private modulesBase: IBaseModule[] = [];
    // Индекс "id родителя -> дочерние модули" для modulesList, пересчитывается
    // один раз при (пере)присвоении modulesList (см. setModulesList), чтобы
    // getParModules/getChildModules не сканировали массив на каждый вызов.
    private modulesByParentId: Map<number, IBaseModule[]> = new Map();
    // Модули шаблона, чей родитель ("...000") не входит в шаблон ("сироты").
    // Такие модули не должны отображаться/редактироваться пользователем, но
    // обязаны попасть в заявку при сохранении (см. addNewUser/getAllModulesWithDescendants).
    private hiddenTemplateModules: IBaseModule[] = [];
    private supportStatus: boolean | null = null;
    private currentUser: IUsers | null = null;
    private curUserFullname: string = "";
    private curUserEmail: string = "";
    private file: any = null as File | null;
    private newUserList: INewUsers[] = [];
    private loading: boolean = false;
    private isLoading: boolean = false;
    private bar: number = 0;
    private isFormEdit: boolean = false;
    private showDelModal: boolean = false;
    private isSendToSupport: boolean = false;
    private isApplyTemplate: boolean = false;
    private isSavedReq: boolean = false;
    private isSavingReq: boolean = false;
    private isEditing: boolean = false;
    private attachedFile: { name: string; url?: string; blob?: Blob } | null =
        null;
    private showOperModal: boolean = false;
    private selectedModule: any = { operations: [] };

    private isLoadFile: boolean = false;
    private isTemplateLoading: boolean = false;
    @Prop({ required: true }) getOperations!: (
        module: string
    ) => Promise<any[]>;
    private isReqCancelled: boolean = false;
    private isReqReturned: boolean = false;
    @Prop({ required: true })
    private hasWorkPlace!: boolean;
    @Prop({ required: true }) workPlaceTypes!: "GU" | "KGKP" | "Both";
    private isTemplateLoadedOnce = false;
    private showUmForm: boolean = false;
    private showReqParamsModal: boolean = false;
    private curUserIin: string = "";
    private guWithGkkpSet: Set<string> = new Set();
    private hasGuGkkp = false;
    private fgrList: any[] = [];
    private abpUmList: any[] = [];
    private regUmList: any[] = [];
    private guUmList: any[] = [];
    private gkkpUmList: any[] = [];
    private workGuUmList: any[] = [];
    private workGkkpUmList: any[] = [];
    private msuUmList: any[] = [];
    private categUmList: any[] = [];
    private canAddUser = false;
    private moduleUmList: any[] = [];
    private activeMenu: string = "";

    private leftUmMenu: { key: string; label: string }[] = [
        { key: "fgr", label: "ФУНКЦИОНАЛЬНЫЕ" },
        { key: "abp", label: "АБП" },
        { key: "regions", label: "РЕГИОНЫ" },
        { key: "gu", label: "ГУ" },
        { key: "gkkp", label: "ГККП" },
        { key: "work_gu", label: "МЕСТО РАБОТЫ ГУ" },
        { key: "work_gkkp", label: "МЕСТО РАБОТЫ ГККП" },
        { key: "msu", label: "МСУ" },
        { key: "categ", label: "КАТЕГОРИЯ ДОХОДОВ" },
        { key: "modules", label: "МОДУЛИ" },
    ];

    get menuList(): Record<string, any[]> {
        return {
            fgr: this.fgrList,
            abp: this.abpUmList,
            regions: this.regUmList,
            gu: this.guUmList,
            gkkp: this.gkkpUmList,
            work_gu: this.workGuUmList,
            work_gkkp: this.workGkkpUmList,
            msu: this.msuUmList,
            categ: this.categUmList,
            modules: this.moduleUmList,
        };
    }

    get currentList(): any[] {
        const list = this.menuList[this.activeMenu] ?? [];

        if (!this.searchQuery) {
            return list;
        }

        const q = this.searchQuery.toLowerCase();

        return list.filter((item) =>
            Object.values(item).some(
                (val: any) => val && val.toString().toLowerCase().includes(q)
            )
        );
    }

    get availableMenus() {
        return this.leftUmMenu.filter(
            (menu) => (this.menuList[menu.key] ?? []).length > 0
        );
    }

    private async loadAllUmData(userId: string) {
        const baseFgrPromise = this.getAllFgrList();
        const baseCategPromise = this.getAllCategory();

        const [baseFgrList, baseCategList] = await Promise.all([
            baseFgrPromise,
            baseCategPromise,
        ]);

        await Promise.allSettled([
            this.getFgrList(baseFgrList, userId),
            this.getCategList(baseCategList, userId),
            this.getAbpList(userId),
            this.getRegionList(userId),
            this.getMsuList(userId),
            this.getGuList(userId),
            this.getGkkpList(userId),
            this.getModuleList(userId),
            this.getUmGuWorkplace(userId),
            this.getUmGkkpWorkplace(userId),
        ]);
    }

    private async loadTabData(key: string) {
        switch (key) {
            case "fgr":
                if (!this.fgrList.length) {
                    const baseFgrList = await this.getAllFgrList();
                    if (baseFgrList) {
                        await this.getFgrList(baseFgrList, this.currentUmUser);
                    }
                }
                break;

            case "categ":
                if (!this.categUmList.length) {
                    const baseList = await this.getAllCategory();
                    if (baseList) {
                        await this.getCategList(baseList, this.currentUmUser);
                    }
                }
                break;

            case "abp":
                if (!this.abpUmList.length) {
                    await this.getAbpList(this.currentUmUser);
                }
                break;

            case "regions":
                if (!this.regUmList.length) {
                    await this.getRegionList(this.currentUmUser);
                }
                break;

            case "msu":
                if (!this.msuUmList.length) {
                    await this.getMsuList(this.currentUmUser);
                }
                await this.loadNames(
                    this.msuUmList,
                    this.getRegName.bind(this)
                );
                break;
            case "modules":
                if (!this.moduleUmList.length) {
                    await this.getModuleList(this.currentUmUser);
                }
                break;

            case "gkkp":
                if (!this.gkkpUmList.length) {
                    await this.getGkkpList(this.currentUmUser);
                }
                await this.loadNames(
                    this.gkkpUmList,
                    this.getGkkpName.bind(this)
                );
                break;

            case "gu":
                if (!this.guUmList.length) {
                    await this.getGuList(this.currentUmUser);
                }
                break;
            case "work_gu":
                if (!this.workGuUmList.length) {
                    await this.getUmGuWorkplace(this.currentUmUser);
                }
                await this.loadNames(
                    this.workGuUmList,
                    this.getGuName.bind(this)
                );
                break;

            case "work_gkkp":
                if (!this.workGkkpUmList.length) {
                    await this.getUmGkkpWorkplace(this.currentUmUser);
                }
                await this.loadNames(
                    this.workGkkpUmList,
                    this.getGkkpName.bind(this)
                );
                break;
        }
    }

    private readonly nameLoaders: Record<string, () => Promise<void>> = {
        gkkp: () =>
            this.loadNames(this.gkkpUmList, this.getGkkpName.bind(this)),
        work_gu: () =>
            this.loadNames(this.workGuUmList, this.getGuName.bind(this)),
        work_gkkp: () =>
            this.loadNames(this.workGkkpUmList, this.getGkkpName.bind(this)),
        msu: () => this.loadNames(this.msuUmList, this.getRegName.bind(this)),
    };

    private async selectMenu(key: string) {
        this.isLoading = true;

        try {
            this.activeMenu = key;
            await this.loadTabData(key);
            await this.$nextTick();
            const el = this.$refs.rightUmContent as HTMLElement;
            if (el) {
                el.scrollTop = 0;
            }
        } finally {
            this.isLoading = false;
        }
    }

    private clearUmLists() {
        this.fgrList = [];
        this.abpUmList = [];
        this.regUmList = [];
        this.guUmList = [];
        this.gkkpUmList = [];
        this.moduleUmList = [];
        this.workGkkpUmList = [];
        this.workGuUmList = [];
        this.categUmList = [];
    }

    private searchQuery: string = "";

    private showAddModChildForm: boolean = false;
    private moduleChildList: any[] = [];
    private searchModChild: string = "";
    private selectedModChildItems: string[] = [];
    private selectAllModChild: boolean = false;
    private selectedUserIndex: number = -1;
    private selectedModIndex: number = -1;

    get reqDate() {
        const currentDate: Date = new Date();
        return currentDate.toLocaleDateString("ru-RU");
    }

    get numberReq() {
        const number = "1";
        return number;
    }

    get statusReq() {
        const status = 1;
        return status;
    }

    get userId() {
        return store.getters.user_uuid;
    }

    private get curLanguage() {
        return this.$i18n.locale || "ru";
    }

    get selectedUser(): any | null {
        return this.reqData.userList.find((u) => u.user.isExpDropdown) || null;
    }

    get orderStatus(): number {
        return this.reqData.order.status;
    }

    get isEditable() {
        return (
            this.mode === "view" &&
            !this.isUserSupport &&
            (this.orderStatus === 1 || this.orderStatus === 27)
        );
    }

    get canEditModules(): boolean {
        if (this.mode === "create") {
            return true;
        }

        if (this.mode !== "view") {
            return false;
        }

        if (!this.isUserSupport) {
            return this.orderStatus === 1 || this.orderStatus === 27;
        }

        return this.orderStatus === 73;
    }

    private async mounted() {
        try {
            await this.getUserGuWork();
            await this.loadDictTypeApp();
            await this.loadDictCategoryApp();
            await this.fetchStatusLabels();
            await this.getServerRegList();
            await this.getRequestList();
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки данных",
                    error.toString()
                );
            }
        }
    }

    public created() {
        this.$watch("typeOrgReq", (newValue) => {
            if (this.mode === "view" && this.reqData?.order?.gkkp) return;

            if (newValue === 0) {
                this.getUserGuWork();
            } else {
                this.getUserKgkpWork();
            }
        });

        this.$watch("selectedGkkp", (newValue) => {
            if (newValue) {
                this.fetchGuForKgkp(newValue.code);
                // this.selectedRegKgkp = newValue.region;
            } else {
                this.selectedKgkpGu = "Нет данных";
                // this.selectedRegKgkp = null;
            }
        });
        this.$watch(
            () => this.reqData?.order?.gkkp,
            async (newVal) => {
                if (this.mode === "view" && this.typeOrgReq === 1 && newVal) {
                    const bin = newVal.split("-")[0].trim();
                    await this.fetchGuForKgkp(bin);
                }
            }
        );

        this.$watch("mode", (newValue) => {
            if (newValue === "view") {
                this.clearErrors();
            }
        });

        this.$watch("selectedGu", (newValue) => {
            if (!newValue?.code) {
                this.hasGuGkkp = false;
                return;
            }

            this.hasGuGkkp = this.guWithGkkpSet.has(newValue.code);
        });
    }

    private clearErrors() {
        this.iinError = {};
        this.nameError = {};
        this.phoneError = {};
        this.emailError = {};
    }

    private iinError: Record<number, string | null> = {};

    private isValidIinLastDigit(iin: string): boolean {
        if (!/^\d{12}$/.test(iin)) {
            return false;
        }

        const digits = iin.split("").map(Number);

        // Первый круг
        const weights1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        const sum1 = digits
            .slice(0, 11)
            .reduce((sum, digit, index) => sum + digit * weights1[index], 0);

        let remainder = sum1 % 11;

        if (remainder < 10) {
            return remainder === digits[11];
        }

        // Второй круг
        const weights2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
        const sum2 = digits
            .slice(0, 11)
            .reduce((sum, digit, index) => sum + digit * weights2[index], 0);

        remainder = sum2 % 11;

        if (remainder === 10) {
            return false;
        }

        return remainder === digits[11];
    }

    private async onIinInput(index: number, value: string) {
        const iin = value.replace(/\D/g, "").slice(0, 12);

        if (this.mode === "create") {
            this.newUserList[index].iin = iin;
        } else if (this.mode === "view" && this.isEditable) {
            const target = this.reqData.userList[index]?.user;
            if (target) {
                target.iin = iin;
            } else {
                console.warn("Некорректный индекс или структура userList");
                return;
            }
        } else {
            return;
        }

        if (iin.length !== 12) {
            this.$set(this.iinError, index, "ИИН должен содержать 12 цифр");
            return;
        }

        //  Проверка символов 3–7
        const third = iin[2];
        const fourth = iin[3];
        const fifth = iin[4];
        const seventh = iin[6];

        const isValid =
            ["0", "1", "2"].includes(third) &&
            /[0-9]/.test(fourth) &&
            ["0", "1", "2", "3"].includes(fifth) &&
            !["1", "2", "7", "8", "9"].includes(seventh);

        if (!isValid) {
            this.$set(
                this.iinError,
                index,
                "Некорректный формат ИИН. Проверьте введенный ИИН."
            );
            return;
        }

        if (!this.isValidIinLastDigit(iin)) {
            this.$set(
                this.iinError,
                index,
                "Некорректный формат ИИН. Проверьте введенный ИИН."
            );
            return;
        }

        let duplicate = false;

        if (this.mode === "create") {
            duplicate = this.newUserList.some(
                (item, i) => i !== index && item.iin === iin
            );
        } else if (this.mode === "view" && this.isEditable) {
            duplicate = this.reqData.userList.some(
                (item, i) => i !== index && item.user?.iin === iin
            );
        }

        if (duplicate) {
            this.$set(
                this.iinError,
                index,
                "Такой ИИН уже введён в данный список"
            );
            return;
        }

        this.$set(this.iinError, index, null);

        try {
            const res = await fetch(
                `/api/um/admin/mode/order/check-iin?iin=${iin}`
            );
            const isUsed = await res.json();
            if (isUsed.first === 1) {
                this.$set(
                    this.iinError,
                    index,
                    isUsed
                        ? "Пользователь с таким ИИН существует в Системе Keycloak"
                        : null
                );
            } else if (isUsed.first === 2) {
                this.$set(
                    this.iinError,
                    index,
                    isUsed
                        ? `Пользователь уже создан в заявке №${isUsed.second}`
                        : null
                );
            } else {
                this.$set(this.iinError, index, null);
            }
        } catch (error) {
            console.error("Ошибка проверки ИИН:", error);
            this.$set(this.iinError, index, "Ошибка проверки ИИН");
        }
    }

    private onlyNumbers(event: KeyboardEvent) {
        const key = event.key;
        if (
            !/[0-9]/.test(key) &&
            key !== "Backspace" &&
            key !== "Delete" &&
            key !== "ArrowLeft" &&
            key !== "ArrowRight"
        ) {
            event.preventDefault();
        }
    }

    private nameError: Record<number, string | null> = {};
    private lastNameError: Record<number, string | null> = {};
    private middleNameError: Record<number, string | null> = {};

    private handleInput(
        index: number,
        field: "lastName" | "firstName" | "middleName",
        value: string
    ) {
        value = value
            .split(" ")
            .filter(Boolean)
            .map((word: string) =>
                word
                    .split("-")
                    .map(
                        (part: string) =>
                            part.charAt(0).toUpperCase() +
                            part.slice(1).toLowerCase()
                    )
                    .join("-")
            )
            .join(" ");
        if (this.mode === "view" && this.isEditable) {
            const user = this.reqData.userList[index]?.user;
            if (!user) return;

            if (field === "lastName") user.lastname = value;
            else if (field === "firstName") user.firstname = value;
            else if (field === "middleName") user.patronymic = value;
        } else if (this.mode === "create") {
            const user = this.newUserList[index];
            if (!user) return;

            if (field === "lastName") user.lastName = value;
            else if (field === "firstName") user.firstName = value;
            else if (field === "middleName") user.middleName = value;
        }

        this.validateName(index);
    }

    private validateName(index: number) {
        let lastName = "";
        let firstName = "";
        let middleName = "";

        if (this.mode === "create") {
            const user = this.newUserList[index];
            lastName = user.lastName ?? "";
            firstName = user.firstName ?? "";
            middleName = user.middleName ?? "";
        } else if (this.mode === "view" && this.isEditable) {
            const user = this.reqData.userList[index]?.user;
            if (!user) return;

            lastName = user.lastname ?? "";
            firstName = user.firstname ?? "";
            middleName = user.patronymic ?? "";
        } else {
            return;
        }

        const isValid = (value: string) =>
            value === "" || /^[А-Яа-яЁё\s-]+$/.test(value.trim());

        this.$set(
            this.lastNameError,
            index,
            isValid(lastName)
                ? null
                : "Поле Фамилия должно содержать только кириллицу"
        );
        this.$set(
            this.nameError,
            index,
            isValid(firstName)
                ? null
                : "Поле Имя должно содержать только кириллицу"
        );

        this.$set(
            this.middleNameError,
            index,
            isValid(middleName)
                ? null
                : "Отчество должно содержать только кириллицу"
        );
    }

    private emailError: Record<number, string | null> = {};

    private isAllowedEmailDomain(value: string) {
        const allowedDomainPattern = /^[^\s@]+@(?:[a-z0-9-]+\.)+kz$/i;
        return allowedDomainPattern.test((value ?? "").trim());
    }

    private allowedDomains = [
        "@gov.kz",
        "@edu.kz",
        "@bilim.kz",
        "@csi.kz",
        "@smartderek.kz",
        "@astana.kz",
        "@103-astana.kz",
        "@almatybilim.kz",
    ];

    private async onEmailInput(
        index: number,
        value: string | null | undefined
    ) {
        const email = (value || "").trim();
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const hasCyrillic = /[А-Яа-яЁё]/.test(email);

        if (this.mode === "create") {
            this.newUserList[index].email = email;
        } else if (this.mode === "view" && this.isEditable) {
            const user = this.reqData.userList[index]?.user;
            if (!user) {
                console.warn("Некорректный индекс или структура userList");
                return;
            }
            user.email = email;
        } else {
            return;
        }

        if (!email) {
            this.$set(this.emailError, index, "Пожалуйста заполните email");
            return;
        }

        if (hasCyrillic) {
            this.$set(
                this.emailError,
                index,
                "Email должен содержать только латиницу"
            );
            return;
        }

        if (!emailRegex.test(email)) {
            this.$set(this.emailError, index, "Введите корректный email");
            return;
        }
        const isAllowedDomain = this.isAllowedEmailDomain(email);

        if (!isAllowedDomain) {
            this.$set(
                this.emailError,
                index,
                `Укажите корпоративный email с доменом .kz`
            );
            return;
        }

        let duplicate = false;

        if (this.mode === "create") {
            duplicate = this.newUserList.some(
                (item, i) => i !== index && item.email === email
            );
        } else if (this.mode === "view" && this.isEditable) {
            duplicate = this.reqData.userList.some(
                (item, i) => i !== index && item.user?.email === email
            );
        }

        if (duplicate) {
            this.$set(
                this.emailError,
                index,
                "Такой почтовый адрес уже введён в данный список"
            );
            return;
        }
        this.$set(this.emailError, index, null);

        try {
            const res = await fetch(
                `/api/um/admin/mode/order/check-email?email=${email}`
            );
            const isUsed = await res.json();
            if (isUsed.first === 1) {
                this.$set(
                    this.emailError,
                    index,
                    isUsed
                        ? "Такой почтовый адрес существует в Системе Keycloak"
                        : null
                );
            } else if (isUsed.first === 2) {
                this.$set(
                    this.emailError,
                    index,
                    isUsed
                        ? `Такой почтовый адрес используется в заявке №${isUsed.second}`
                        : null
                );
            } else {
                this.$set(this.emailError, index, null);
            }
        } catch (error) {
            console.error("Ошибка проверки email:", error);
            this.$set(this.emailError, index, "Ошибка проверки email");
        }
    }

    private phoneError: Record<number, string | null> = {};

    private readonly phoneAllowedControlKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Home",
        "End",
        "Enter",
    ];

    private onPhoneKeydown(event: KeyboardEvent) {
        if (
            event.ctrlKey ||
            event.metaKey ||
            this.phoneAllowedControlKeys.includes(event.key)
        ) {
            return;
        }

        if (!/^[0-9+]$/.test(event.key)) {
            event.preventDefault();
        }
    }

    private async onPhoneInput(index: number, value: string | undefined) {
        const cleaned = (value || "").replace(/\D/g, "");

        let formatted = "+7";
        if (cleaned.length > 1) formatted += ` ${cleaned.slice(1, 4)}`;
        if (cleaned.length > 4) formatted += ` ${cleaned.slice(4, 7)}`;
        if (cleaned.length > 7) formatted += ` ${cleaned.slice(7, 9)}`;
        if (cleaned.length > 9) formatted += ` ${cleaned.slice(9, 11)}`;

        if (formatted.length > 16) {
            formatted = formatted.substring(0, 16);
        }

        if (this.mode === "create") {
            this.newUserList[index].phone = formatted;
        } else if (this.mode === "view" && this.isEditable) {
            const user = this.reqData.userList[index]?.user;
            if (!user) {
                console.warn("Некорректный индекс или структура userList");
                return;
            }
            user.phone = formatted;
        } else {
            return;
        }

        const phoneRegex = /^\+7 7\d{2} \d{3} \d{2} \d{2}$/;

        if (!phoneRegex.test(formatted)) {
            this.$set(
                this.phoneError,
                index,
                "Укажите корректный номер телефона, доступный в WhatsApp."
            );
        } else {
            this.$set(this.phoneError, index, null);
        }

        let duplicate = false;

        const encodedPhone = encodeURIComponent(formatted);

        if (this.mode === "create") {
            duplicate = this.newUserList.some(
                (item, i) => i !== index && item.phone === formatted
            );
        } else if (this.mode === "view" && this.isEditable) {
            duplicate = this.reqData.userList.some(
                (item, i) => i !== index && item.user?.phone === formatted
            );
        }

        if (duplicate) {
            this.$set(
                this.phoneError,
                index,
                "Такой номер телефона уже введён в данный список"
            );
            return;
        }
        this.$set(this.phoneError, index, null);
        try {
            const res = await fetch(
                `/api/um/admin/mode/order/check-phone?phone=${encodedPhone}`
            );
            const isUsed = await res.json();
            if (isUsed.first === 1) {
                this.$set(
                    this.phoneError,
                    index,
                    isUsed
                        ? "Такой номер телефона существует в Системе Keycloak"
                        : null
                );
            } else if (isUsed.first === 2) {
                this.$set(
                    this.phoneError,
                    index,
                    isUsed
                        ? `Такой номер телефона используется в заявке №${isUsed.second}`
                        : null
                );
            } else {
                this.$set(this.phoneError, index, null);
            }
        } catch (error) {
            console.error("Ошибка проверки номера телефона:", error);
            this.$set(
                this.phoneError,
                index,
                "Ошибка проверки номера телефона"
            );
        }
    }

    // filtering workplace
    private async getUserGuWork() {
        try {
            const response = await fetch("/api/um/user-gu-list");
            const guWpData = await response.json();

            if (guWpData && guWpData.length > 0) {
                this.guList = guWpData.map((item: any) => {
                    return {
                        text: `${item.code} - ${item.nameRu}`,
                        code: item.code,
                    };
                });
            } else {
                const guRes = await fetch(
                    `/api-py/dict-user-gu-names/${this.userId}`
                );
                const guData = await guRes.json();
                this.guList = guData.map((item: any) => {
                    return {
                        text: `${item.code} - ${item.name_ru}`,
                        code: item.code,
                    };
                });
            }
            if (this.guList.length > 0) {
                this.selectedGu = this.guList[0];
            } else {
                this.selectedGu = null;
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки место работы для: " + this.userId,
                    error.toString()
                );
            }
        }
    }

    // filtering region

    async fetchGuListForRegion(regionCode: any) {
        try {
            const response = await fetch(
                `/api/um/user-gu-list?region=${regionCode}`
            );
            const data = await response.json();

            this.guList = data.map((item: any) => ({
                text: `${item.code} - ${item.nameRu}`,
                code: item.code,
            }));

            if (this.guList.length > 0) {
                this.selectedGu = this.guList[0];
            } else {
                this.selectedGu = null;
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки список ГУ для региона: " + regionCode,
                    error.toString()
                );
            }
        }
    }

    private async fetchGuForKgkp(kgkpCode: string) {
        try {
            const kgkpDataResponse = await fetch(
                `/api-py/dict-kgkp-by-code/${kgkpCode}`
            );
            const kgkpDataArray = await kgkpDataResponse.json();

            const kgkpDataItem = kgkpDataArray.find(
                (kgkp: any) => kgkp.bin === kgkpCode
            );

            if (!kgkpDataItem) {
                console.warn(`Не найдено ГККП с BIN = ${kgkpCode}`);
                this.selectedKgkpGu = "ГУ не найдено";
                return;
            }

            let guName = "";
            if (kgkpDataItem.code_gu) {
                guName = await this.getGuName(kgkpDataItem.code_gu);
                this.selectedKgkpGu = `${kgkpDataItem.code_gu} - ${guName}`;
            } else {
                this.selectedKgkpGu = "Код ГУ не указан";
            }
        } catch (error) {
            console.error("Ошибка получения данных ГУ:", error);
            this.selectedKgkpGu = "Ошибка получения данных ГУ";
        }
    }

    private guNameCache: Map<string, string> = new Map();
    private gkkpNameCache: Map<string, string> = new Map();
    private regNameCache: Map<string, string> = new Map();

    private async getGuName(guCode: string): Promise<string> {
        if (this.guNameCache.has(guCode)) {
            const cachedName = this.guNameCache.get(guCode)!;
            return cachedName;
        }

        try {
            const resGu = await fetch(`/api-py/dict-gu-by-code/${guCode}`);
            const guDataArray = await resGu.json();
            const guData = Array.isArray(guDataArray)
                ? guDataArray.find((gu: any) => gu.code === guCode)
                : guDataArray;

            const name = guData ? guData.name_ru : "ГУ не найдено";
            this.guNameCache.set(guCode, name);

            return name;
        } catch (error) {
            console.error(`Ошибка получения данных ГУ ${guCode}:`, error);
            this.guNameCache.set(guCode, "Ошибка получения данных ГУ");
            return "Ошибка получения данных ГУ";
        }
    }

    private async getGkkpName(bin: string): Promise<string> {
        const start = performance.now();
        if (this.gkkpNameCache.has(bin)) {
            const cachedName = this.gkkpNameCache.get(bin)!;

            return cachedName;
        }

        try {
            const res = await fetch(`/api-py/dict-kgkp-by-code/${bin}`);
            const data = await res.json();
            const gkkp = Array.isArray(data)
                ? data.find((item: any) => item.bin === bin)
                : data;

            const name = gkkp ? gkkp.name_ru : "ГККП не найдено";
            this.gkkpNameCache.set(bin, name);

            return name;
        } catch (error) {
            console.error(`Ошибка получения данных ГККП ${bin}:`, error);
            this.gkkpNameCache.set(bin, "Ошибка получения данных ГККП");
            return "Ошибка получения данных ГККП";
        }
    }

    private async getUserKgkpWork() {
        try {
            const resWpGkkp = await fetch("/api/um/user-kgkp-list");
            const gkkpWpData = await resWpGkkp.json();

            if (gkkpWpData && gkkpWpData.length > 0) {
                this.gkkpList = gkkpWpData.map((item: any) => ({
                    text: `${item.code} - ${item.nameRu}`,
                    code: item.code,
                }));
            } else {
                const resGkkp = await fetch(`api-py/user-kgkp/${this.userId}`);
                const gkkpData = await resGkkp.json();

                const listWithNames: { text: string; code: string }[] =
                    await Promise.all(
                        gkkpData.map(async (item: any) => {
                            const name = await this.getGkkpName(item.kgkp);
                            return {
                                text: `${item.kgkp} - ${name}`,
                                code: item.kgkp,
                            };
                        })
                    );

                this.gkkpList = listWithNames;
            }

            if (this.gkkpList.length > 0) {
                this.selectedGkkp = this.gkkpList[0];
            } else {
                this.selectedGkkp = null;
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    `Ошибка загрузки места работы для пользователя ${this.userId}`,
                    error.toString()
                );
            }
        }
    }

    private async loadGuWithGkkp(): Promise<void> {
        if (this.guWithGkkpSet.size > 0) {
            return;
        }

        const response = await fetch("/api-py/gu-with-kgkp");
        const data: string[] = await response.json();

        this.guWithGkkpSet = new Set(data);
    }

    private async applyReqParams() {
        try {
            if (
                (this.typeOrgReq === 0 && !this.selectedGu?.code) ||
                (this.typeOrgReq === 1 && !this.selectedGkkp?.code)
            ) {
                this.makeToast(
                    "warning",

                    this.typeOrgReq === 0
                        ? "Для создания новой заявки необходимо выбрать ГУ"
                        : "Для создания новой заявки необходимо выбрать ГККП",
                    "Внимание"
                );
                return;
            }
            this.showReqParamsModal = false;

            await this.openAddForm();
            this.hasGuGkkp = this.guWithGkkpSet.has(this.selectedGu?.code);
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка при открытии форму заявки",
                    error.toString()
                );
            }
        }
    }

    private resetFormData() {
        this.hasGuGkkp = false;
        this.isApplyTemplate = false;
        this.file = null;
        this.reqData.order.headName = "";
        this.newUserList = [];
        this.usersList = [];
    }

    private resetFilterData() {
        this.typeOrgReq = 0;
        if (this.typeOrgReq === 0) {
            if (this.selectedRegion) {
                this.selectedRegion = this.regionList[0];
                this.selectedGu = this.guList[0];
            } else {
                this.selectedGu = this.guList[0];
            }
        } else {
            if (this.selectedRegionKgkp) {
                this.selectedRegionKgkp = this.regionList[0];
                this.selectedGkkp = this.gkkpList[0];
            } else {
                this.selectedGkkp = this.gkkpList[0];
            }
        }
    }

    private initNewRequestData() {
        this.reqData = {
            order: {
                id: 0,
                dictVwOrder: 0,
                dictVwOrderId: 0,
                dictAppTypeAppId: 0,
                userId: "",
                createDate: 0,
                isSaveFile: false,
                status: 1,
                gu: "",
                guCode: "",
                gkkp: null,
                gkkpCode: "",
                kato: null,
                headName: "",
                num: "",
                region: "",
            },
            userList: [],
        };
    }

    private async openReqParamsModal() {
        this.showReqParamsModal = true;
        await this.loadGuWithGkkp();
    }

    private async openAddForm() {
        this.mode = "create";
        this.$emit("create-new-request", { mode: "create" });
        this.clearErrors();
        this.initNewRequestData();
        this.isSavedReq = false;
        this.resetFormData();
        this.showRequestForm = true;
        this.backReqList = false;
        await this.getCurUserInfo();
        await this.loadAndCacheModules();
    }

    get initiatorFullName(): string {
        return this.initiator?.fullName || this.currentUser?.fullName || "";
    }

    private initiator: {
        firstName: string;
        lastName: string;
        fullName: string;
    } | null = null;

    private async getUserInfo(userId: string) {
        try {
            const response = await axios.get(
                `/api-py/get-realm-user/${userId}`
            );

            const data = response.data;

            return {
                ...data,
                fullName: `${data.firstName} ${data.lastName}`,
            };
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса информации о пользователе",
                    error.message
                );
            }

            return null;
        }
    }

    private async getCurUserInfo() {
        this.currentUser = await this.getUserInfo(this.userId);
    }

    private async backToReqList() {
        this.backReqList = true;
        this.showRequestForm = false;
        this.isApplyTemplate = false;
        await this.getRequestList();
        this.resetFilterData();
        this.resetFormData();
        this.selectedAppType = this.typeAppList[0];
        this.selectedCategApp =
            this.categoryAppList.find((el) => el.code === "01") ?? null;
    }

    private backToReqForm() {
        this.showRequestForm = true;
        this.showUmForm = false;
    }

    private async loadDictTypeApp() {
        try {
            const response = await fetch("/api/dict/vw_order");
            const data = await response.json();

            this.typeAppList = data.map((item: any) => ({
                ...item,
                text:
                    this.$i18n.locale === "kk"
                        ? item.nameKk
                        : this.$i18n.locale === "en"
                        ? item.nameEn
                        : item.nameRu,
            }));
            this.selectedAppType = this.typeAppList[0];
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса видов заявок",
                    error.toString()
                );
            }
        }
    }

    private async loadDictCategoryApp() {
        try {
            const response = await fetch("/api/dict/app_type_app");
            const data = await response.json();

            this.categoryAppList = data.map((item: any) => ({
                ...item,
                text:
                    this.$i18n.locale === "kk"
                        ? item.nameKk
                        : this.$i18n.locale === "en"
                        ? item.nameEn
                        : item.nameRu,
            }));

            this.selectedCategApp =
                this.categoryAppList.find((el) => el.code === "01") ?? null;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса категорий заявок",
                    error.toString()
                );
            }
        }
    }

    private formatDate(timestamp: number): string {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    private formatTime(timestamp: number): string {
        const date = new Date(timestamp);
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${hours}:${minutes}`;
    }

    private formatDateTime(timestamp: number): string {
        return new Date(timestamp).toLocaleString("ru-RU", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    }

    private statusLabels: Record<number, string> = {};

    private async fetchStatusLabels() {
        try {
            const param = encodeURI(JSON.stringify({ mode_code: "admin" }));
            const response = await fetch(
                `/api-py/get-all-agreement-status/${param}`
            );
            const result = await response.json();

            const statusMap: Record<number, string> = {};

            for (const item of result) {
                let label = "";

                if (this.$i18n.locale === "kk") {
                    label = item.name_kk;
                } else if (this.$i18n.locale === "en") {
                    label = item.name_en;
                } else {
                    label = item.name_ru;
                }

                statusMap[item.code] = label;
            }
            this.statusLabels = statusMap;
        } catch (error) {
            console.error("Ошибка загрузки статусов:", error);
        }
    }

    private getProjectStatusLabel(status: number): string {
        return this.statusLabels[status] || "";
    }

    get filteredRequestsList() {
        return this.requestsList.filter((item) => {
            const matchIIN = this.searchIIN
                ? item.num?.toString().includes(this.searchIIN)
                : true;

            const matchName = this.searchName
                ? item.userName
                      ?.toLowerCase()
                      .includes(this.searchName.toLowerCase())
                : true;

            return matchIIN && matchName;
        });
    }

    private onRegionChange() {
        this.getRequestList();
    }

    private async getRequestList() {
        try {
            this.loading = true;
            this.bar = 0;

            const queryParams: any = {
                ...(this.selectedRegServer?.id !== 0 && {
                    region: this.selectedRegServer.code,
                }),
            };

            const response = await axios.get(
                `api/um/admin/mode/order/list?lang=${this.$i18n.locale}`,
                {
                    params: queryParams,
                }
            );

            const requests = response.data;
            const reqList = requests.map((item: any) => {
                return {
                    ...item,
                    status: item.status,
                    statusName: item.status
                        ? this.getProjectStatusLabel(item.status)
                        : "",
                    createDate: item.createDate
                        ? this.formatDate(item.createDate)
                        : null,
                    createTime: item.createDate
                        ? this.formatTime(item.createDate)
                        : null,
                    updateDate: item.createDate,
                };
            });

            this.requestsList = reqList.sort(
                (a: any, b: any) => (b.updateDate || 0) - (a.updateDate || 0)
            );
            this.bar = 100;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса списка заявок",
                    error.message
                );
            }
        } finally {
            this.loading = false;
        }
    }

    private async openRequestCard(item: Order) {
        if (item.id === null) {
            console.error("Нельзя открыть заявку без id");
            this.makeToast(
                "danger",
                "Ошибка",
                "Невозможно открыть заявку без идентификатора"
            );
            return;
        }

        try {
            await this.getCurUserInfo();
            const currentUserId = this.userId;

            if (
                this.isUserSupport &&
                item.status === 73 &&
                item.userIdSupport !== currentUserId
            ) {
                this.makeToast(
                    "warning",
                    `Заявка №${item.num} обрабатывается специалистом: ${item.userNameSupport}`,
                    "Заявка заблокирована"
                );
                return;
            }

            await this.loadAndCacheModules();
            this.selectedRequest = item;
            this.$emit("select-request", item);
            await this.getDetailRequest({ id: item.id });

            await this.loadGuWithGkkp();

            this.hasGuGkkp =
                !!this.reqData.order.guCode &&
                this.guWithGkkpSet.has(this.reqData.order.guCode);

            this.isFormEdit = false;
            this.showRequestForm = true;
            this.backReqList = false;
            this.mode = "view";
            this.isTemplateLoadedOnce = false;
        } catch (error) {
            console.error("Ошибка при открытии заявки:", error);
            this.makeToast(
                "danger",
                "Ошибка",
                "Не удалось открыть заявку. Попробуйте еще раз."
            );
        }
    }

    private getAppTypeName(id: number) {
        return this.typeAppList.find((b: any) => b.id === id)?.nameRu || "";
    }

    private getCategTypeName(id: number) {
        return this.categoryAppList.find((b: any) => b.id === id)?.nameRu || "";
    }

    private convertToNewUserList(userList: UserList[]): INewUsers[] {
        return userList.map((item) => ({
            iin: item.user.iin,
            firstName: item.user.firstname,
            lastName: item.user.lastname,
            middleName: item.user.patronymic || "",
            phone: item.user.phone || "",
            email: item.user.email || "",
            gu: "",
            isAdductor: item.user.isAggregate || false,
            modules: item.moduleList,
            isExpDropdown: item.isExpDropdown,
        }));
    }

    private modulesDict: Record<string, string> = {};

    private async loadAndCacheModules(): Promise<void> {
        try {
            const response = await fetch("/api-py/sic-modules");
            const data = await response.json();

            // Словарь модулей
            this.modulesDict = {};
            for (const item of data) {
                this.modulesDict[item.code] = item.name_ru;
            }
            this.modulesBase = data.filter((item: any) => {
                return item.code && typeof item.code === "string";
            });
            // this.modulesBase = data.filter((item: any) => {
            //     if (!item.code || typeof item.code !== "string") {
            //         return false;
            //     }

            //     const codeParts = item.code.split(".").map(Number);
            //     const limitParts = "006.000".split(".").map(Number);

            //     return (
            //         codeParts[0] < limitParts[0] ||
            //         (codeParts[0] === limitParts[0] &&
            //             codeParts[1] <= limitParts[1])
            //     );
            // });

            this.modulesBase.sort((a, b) => a.code.localeCompare(b.code));
        } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка загрузки модулей",
                error instanceof Error ? error.message : "Неизвестная ошибка"
            );
        }
    }

    private loadingFile: boolean = false;

    private async getDetailRequest(item: { id: number }): Promise<void> {
        try {
            this.loading = true;
            const start = performance.now();

            this.attachedFile = null;
            this.loadingFile = false;

            const response = await fetch(
                `/api/um/admin/mode/order/id?idorder=${item.id}`
            );
            const reqDetails: RequestResponse = await response.json();

            this.initiator = reqDetails.order.userId
                ? await this.getUserInfo(reqDetails.order.userId)
                : null;

            const [guName, gkkpName] = await Promise.all([
                reqDetails.order.gu
                    ? this.getGuName(reqDetails.order.gu)
                    : Promise.resolve(""),
                reqDetails.order.gkkp
                    ? this.getGkkpName(reqDetails.order.gkkp)
                    : Promise.resolve(""),
            ]);

            if (reqDetails.order.isSaveFile) {
                await this.loadAttachedFile(item.id);
            } else {
                this.attachedFile = null;
            }

            if (reqDetails.order.gkkp) {
                await this.fetchGuForKgkp(reqDetails.order.gkkp);
            }

            this.typeOrgReq =
                reqDetails.order.gu && !reqDetails.order.gkkp
                    ? 0
                    : !reqDetails.order.gu && reqDetails.order.gkkp
                    ? 1
                    : this.typeOrgReq;

            this.reqData = {
                order: {
                    ...reqDetails.order,
                    formattedCreateDate: this.formatDate(
                        reqDetails.order.createDate
                    ),
                    dictVwOrder: this.getAppTypeName(
                        reqDetails.order.dictVwOrder
                    ),
                    dictVwOrderId: reqDetails.order.dictVwOrder,
                    dictAppTypeAppId: this.getCategTypeName(
                        reqDetails.order.dictAppTypeAppId
                    ),
                    statusName: this.getProjectStatusLabel(
                        reqDetails.order.status
                    ),
                    gu: reqDetails.order.gu
                        ? `${reqDetails.order.gu}-${guName}`
                        : "",
                    guCode: reqDetails.order.gu,
                    gkkp: reqDetails.order.gkkp
                        ? `${reqDetails.order.gkkp}-${gkkpName}`
                        : "",
                    gkkpCode: reqDetails.order.gkkp ?? "",
                },
                userList: reqDetails.userList
                    .map((user) => {
                        const moduleList = user.moduleList;
                        const parentModules = moduleList
                            .filter((mod) => mod.modules.endsWith(".000"))
                            .sort((a, b) => a.modules.localeCompare(b.modules))
                            .map((mod) => {
                                const prefix = mod.modules.replace(
                                    /\.000$/,
                                    ""
                                );
                                const children = moduleList
                                    .filter(
                                        (child) =>
                                            child.modules.startsWith(prefix) &&
                                            child.modules !== mod.modules
                                    )
                                    .sort((a, b) =>
                                        a.modules.localeCompare(b.modules)
                                    )
                                    .map((child) => ({
                                        ...child,
                                        code: child.modules,
                                        name_ru:
                                            this.modulesDict[child.modules] ||
                                            child.modules,
                                        canEdit: child.accessLevel > 1,
                                        canAgree:
                                            Array.isArray(child.operations) &&
                                            child.operations.length > 0,
                                    }));

                                const hasEditableChildren = children.some(
                                    (child) => child.accessLevel > 1
                                );

                                return {
                                    ...mod,
                                    code: mod.modules,
                                    name_ru:
                                        this.modulesDict[mod.modules] ||
                                        mod.modules,
                                    isModuleDrown: false,
                                    canEdit:
                                        mod.accessLevel > 1 ||
                                        hasEditableChildren,
                                    canAgree: children.some(
                                        (child) =>
                                            Array.isArray(child.operations) &&
                                            child.operations.length > 0
                                    ),
                                    children,
                                };
                            });

                  
                        const usedModuleCodes = new Set<string>();
                        parentModules.forEach((parent) => {
                            usedModuleCodes.add(parent.modules);
                            parent.children.forEach((child: any) =>
                                usedModuleCodes.add(child.modules)
                            );
                        });

                        const hiddenModules = moduleList
                            .filter((mod) => !usedModuleCodes.has(mod.modules))
                            .map((mod) => ({
                                ...mod,
                                code: mod.modules,
                                name_ru:
                                    this.modulesDict[mod.modules] ||
                                    mod.modules,
                                canEdit: mod.accessLevel > 1,
                                canAgree:
                                    Array.isArray(mod.operations) &&
                                    mod.operations.length > 0,
                            }));

                        return {
                            ...user,
                            user: { ...user.user, isExpDropdown: false },
                            modulesHierarchy: parentModules,
                            hiddenModules,
                        };
                    })
                    .sort((a, b) => Number(a.user?.id) - Number(b.user?.id)),
            };
            await this.markModulesHasOperations();
        } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка при загрузке детальных данных заявки",
                error instanceof Error ? error.message : "Неизвестная ошибка"
            );
        } finally {
            this.loading = false;
        }
    }

    // Load file blob and URL
    private async loadAttachedFile(id: number): Promise<void> {
        if (this.attachedFile && this.attachedFile.blob) {
            return;
        }

        this.loadingFile = true;
        try {
            // const start = performance.now();
            const fileResp = await fetch(
                `/api/um/admin/mode/order/get-file?idorder=${id}`
            );
            if (fileResp.status === 200) {
                const blob = await fileResp.blob();
                const fileNameFromHeader = this.getFileNameFromHeader(
                    fileResp.headers.get("Content-Disposition")
                );
                this.attachedFile = {
                    name: fileNameFromHeader || `Файл_заявки_${id}`,
                    blob,
                    url: URL.createObjectURL(blob),
                };
            } else {
                this.attachedFile = null;
                this.makeToast(
                    "danger",
                    "Ошибка загрузки файла",
                    "Файл не найден или недоступен"
                );
            }
        } catch (error) {
            this.attachedFile = null;
            this.makeToast(
                "danger",
                "Ошибка загрузки файла",
                error instanceof Error ? error.message : "Неизвестная ошибка"
            );
        } finally {
            this.loadingFile = false;
        }
    }

    private getFileNameFromHeader(
        contentDisposition: string | null
    ): string | null {
        if (!contentDisposition) {
            return null;
        }

        const regex = /filename\*?[^;=\n]*=((['"]).*?\2|[^;\n]*)/i;
        const match = contentDisposition.match(regex);
        if (match && match[1]) {
            const fileName = match[1].replace(/['"]/g, "").trim();
            return fileName;
        }

        console.warn(
            `Failed to parse Content-Disposition: ${contentDisposition}`
        );
        return null;
    }

    private confirmDelReq(item?: any) {
        if (item) this.selectedRequest = item;
        this.showDelModal = true;
    }

    private async openCommentHistory(item: any) {
        this.selectedRequest = item;
        this.showComHistModal = true;
        await this.loadCommentsHistory(item.id);
    }

    private async openStatusHistory(item: any) {
        this.selectedRequest = item;
        await this.loadStatusHistory(item.id);
        this.showStatusHistModal = true;
    }

    private cancelDelete() {
        this.showDelModal = false;
        this.selectedRequest = null;
    }

    private async deleteRequest() {
        if (this.selectedRequest && this.selectedRequest.id) {
            try {
                const id = this.selectedRequest.id;
                const response = await axios.delete(
                    `/api/um/admin/mode/order/del/${id}`
                );

                if (response.status === 200) {
                    this.makeToast(
                        "success",
                        "Заявка успешно удалена.",
                        "Удаление заявки"
                    );
                    await this.getRequestList();
                    await this.fetchStatusLabels();
                    this.backReqList = true;
                    this.showRequestForm = false;
                } else {
                    throw new Error(`Ошибка сервера: ${response.status}`);
                }
            } catch (error) {
                if (error instanceof Error) {
                    this.makeToast(
                        "danger",
                        "Ошибка при удалении заявки",
                        error.toString()
                    );
                }
            }
        }
        this.showDelModal = false;
    }

    private hasValidationErrors(): boolean {
        const currentUserList =
            this.mode === "view" ? this.reqData.userList : this.newUserList;

        return currentUserList.some(
            (_: UserList | INewUsers, index: number) =>
                this.iinError[index] ||
                this.nameError[index] ||
                this.lastNameError[index] ||
                this.middleNameError[index] ||
                this.emailError[index] ||
                this.phoneError[index]
        );
    }

    private validateRequiredFields(): boolean {
        let hasErrors = false;

        const currentUserList =
            this.mode === "view"
                ? this.reqData.userList.map((u) => u.user)
                : this.newUserList;

        currentUserList.forEach((user: any, index: number) => {
            if (!user.iin) {
                this.$set(this.iinError, index, "ИИН обязателен");
                hasErrors = true;
            }

            const lastName = user.lastname || user.lastName || "";
            const firstName = user.firstname || user.firstName || "";
            if (!lastName || !firstName) {
                this.$set(this.nameError, index, "Фамилия и Имя обязательны");
                hasErrors = true;
            }

            if (!user.email) {
                this.$set(this.emailError, index, "Email обязателен");
                hasErrors = true;
            }

            const phone = user.phone || "";
            if (!phone || phone === "+7") {
                this.$set(this.phoneError, index, "Моб. телефон обязателен");
                hasErrors = true;
            }
        });

        return !hasErrors;
    }

    private async handleSaveClick() {
        if (this.isSavingReq) return;
        this.isSavingReq = true;
        try {
            if (!this.isUserSupport) {
                await this.saveRequest();
            } else {
                await this.updateRequest();
            }
        } finally {
            this.isSavingReq = false;
        }
    }

    private async saveRequest(): Promise<void> {
        if (!this.reqData.order.headName) {
            this.makeToast(
                "warning",
                "Необходимо заполнить ФИО руководителя.",
                "Ошибка валидации"
            );
            return;
        }
        if (!this.validateRequiredFields()) {
            this.makeToast(
                "warning",
                "Необходимо заполнить обязательные поля.",
                "Ошибка валидации"
            );
            return;
        }
        if (this.hasValidationErrors()) {
            this.makeToast(
                "warning",
                "Пожалуйста, перед сохранением исправьте ошибки в форме.",
                "Ошибка валидации"
            );
            return;
        }

        const hasUsers =
            (this.mode === "create" && this.newUserList.length > 0) ||
            (this.mode === "view" && this.reqData.userList.length > 0);

        if (!hasUsers) {
            this.makeToast(
                "warning",
                "Пожалуйста, добавьте пользователей в список заявки.",
                "Ошибка валидации"
            );
            return;
        }
        try {
            const payload = this.buildPayload();

            
            const iins = payload.userList.map((u: any) => u.user.iin);
            const dupIin = iins.find(
                (iin: string, i: number) => iins.indexOf(iin) !== i
            );
            if (dupIin) {
                this.makeToast(
                    "warning",
                    `ИИН ${dupIin} указан в заявке более одного раза.`,
                    "Ошибка валидации"
                );
                return;
            }

            const response = await axios.post(
                "/api/um/admin/mode/order/save",
                payload
            );

            if (response.status !== 200) {
                throw new Error(`Ошибка: ${response.status}`);
            }
            this.reqData.order.id = response.data;

            const uploadSuccess = this.file
                ? await this.uploadFile(response.data)
                : true;

            if (!uploadSuccess) {
                throw new Error("Ошибка при загрузке файла.");
            }

            this.isLoadFile = true;
            this.isSavedReq = true;
            this.mode = "view";
            this.isApplyTemplate = false;
            await this.getDetailRequest({
                id: this.reqData.order.id as number,
            });
            // this.selectedRequest = this.reqData.order as any;
            this.$emit("select-request", this.reqData.order);

            this.makeToast(
                "success",
                "Заявка успешно сохранена. Необходимо скачать форму заявки, подписать у руководителя и заверить печатью.",
                "Сохранение заявки",
                6000
            );
        } catch (error) {
            console.error("Ошибка при сохранении:", error);
            this.makeToast(
                "danger",
                "Ошибка при сохранении заявки",
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    private buildPayload() {
        const orderId = this.reqData.order?.id
            ? { id: this.reqData.order.id }
            : {};
        const orderNum = this.reqData.order?.num
            ? { num: this.reqData.order.num }
            : {};

        const currentUserList: (UserList | INewUsers)[] =
            this.mode === "view" ? this.reqData.userList : this.newUserList;
        const curStatus =
            this.mode === "create" ? 1 : this.reqData.order.status;

        const userListPayload = currentUserList.map((userData: any) => {
            const user = this.mode === "view" ? userData.user : userData;
            const userModules =
                this.mode === "view"
                    ? userData.modulesHierarchy || []
                    : user.modules || [];
            // Модули-сироты, привязанные к пользователю в момент применения
            // шаблона (addNewUser). Для заявок, загруженных до этой доработки,
            // поле может отсутствовать — тогда просто нечего подмешивать.
            const userHiddenModules: IBaseModule[] =
                (this.mode === "view"
                    ? userData.hiddenModules
                    : user.hiddenModules) || [];

            const fullModuleList = this.getAllModulesWithDescendants(
                userModules,
                userHiddenModules
            );

            return {
                user: {
                    id: user.id ?? null,
                    iin: user.iin,
                    firstname: user.firstname || user.firstName || "",
                    lastname: user.lastname || user.lastName || "",
                    email: user.email || "",
                    patronymic: user.patronymic || user.middleName || null,
                    phone: user.phone || "+7",
                    isAggregate: user.isAggregate || user.isAdductor || false,
                },
                moduleList: fullModuleList.map((mod) => ({
                    id: null,
                    modules: mod.modules,
                    accessLevel: mod.accessLevel ?? (mod.canEdit ? 2 : 1),
                    operations:
                        mod.canAgree &&
                        Array.isArray(mod.operations) &&
                        mod.operations.length > 0
                            ? [...mod.operations]
                            : [],
                })),
            };
        });

        return {
            order: {
                ...orderId,
                ...orderNum,
                dictVwOrder: this.selectedAppType?.id || 1,
                dictAppTypeAppId: this.selectedCategApp?.id || 1,
                userId: this.userId,
                createDate: new Date().toISOString(),
                isSaveFile: !!this.file,
                status: curStatus,
                gu:
                    this.typeOrgReq === 0
                        ? this.selectedGu?.code || this.reqData.order.guCode
                        : null,
                gkkp:
                    this.typeOrgReq === 1
                        ? this.selectedGkkp?.code || this.reqData.order.gkkpCode
                        : null,
                kato: null,
                headName: this.reqData.order.headName,
            },
            userList: userListPayload,
        };
    }

    private getAllModulesWithDescendants(
        userModules: any[],
        hiddenModules: IBaseModule[] = []
    ) {
        const fullModuleMap: Record<string, boolean> = {};
        const modulesToSend: any[] = [];
        const moduleList = this.modulesList || [];

        for (const selected of userModules) {
            if (fullModuleMap[selected.modules]) continue;

            modulesToSend.push({
                modules: selected.modules,
                accessLevel: selected.accessLevel ?? (selected.canEdit ? 2 : 1),
                canEdit: selected.canEdit || false,
                canAgree: selected.canAgree || false,
                operations: selected.canAgree
                    ? Array.isArray(selected.operations)
                        ? [...selected.operations]
                        : []
                    : [],
            });

            fullModuleMap[selected.modules] = true;

            const isParent = selected.modules.endsWith(".000");
            if (!isParent) continue;

            const existingChildren: any[] = Array.isArray(selected.children)
                ? selected.children
                : [];

            for (const child of existingChildren) {
                if (fullModuleMap[child.modules]) continue;

                modulesToSend.push({
                    modules: child.modules,
                    accessLevel: child.accessLevel ?? (child.canEdit ? 2 : 1),
                    canEdit: child.canEdit || false,
                    canAgree: child.canAgree || false,
                    operations: child.canAgree
                        ? Array.isArray(child.operations)
                            ? [...child.operations]
                            : []
                        : [],
                });
                fullModuleMap[child.modules] = true;
            }

            const prefix = selected.modules.replace(/\.000$/, "");
            const descendants = moduleList.filter(
                (m) =>
                    m.modules.startsWith(prefix) &&
                    m.modules !== selected.modules &&
                    !fullModuleMap[m.modules]
            );

            for (const child of descendants) {
                const templateLevel = child.access_level ?? 1;
                const accessLevel = selected.canEdit ? templateLevel : 1;

                modulesToSend.push({
                    modules: child.modules,
                    accessLevel,
                    canEdit: accessLevel > 1,
                    canAgree: selected.canAgree || false,
                    operations: Array.isArray(child.operations)
                        ? [...child.operations]
                        : [],
                });
                fullModuleMap[child.modules] = true;
            }
        }


        for (const hidden of hiddenModules) {
            if (fullModuleMap[hidden.modules]) continue;

            const operations = Array.isArray(hidden.operations)
                ? [...hidden.operations]
                : [];

            modulesToSend.push({
                modules: hidden.modules,
                accessLevel: hidden.accessLevel ?? 1,
                canEdit: hidden.canEdit ?? false,
                canAgree: hidden.canAgree ?? false,
                operations,
            });
            fullModuleMap[hidden.modules] = true;
        }

        return modulesToSend;
    }

    private async updateRequest() {
        if (!this.reqData.userList?.length) {
            this.makeToast(
                "warning",
                "Список пользователей пуст. Нет модулей для обновления.",
                "Внимание!"
            );
            return;
        }

        const payload = this.reqData.userList.map((userData: any) => {
            const userId = userData.user?.id;

            const moduleList = (userData.modulesHierarchy || []).flatMap(
                (parent: any) => {
                    const parentPayload = {
                        id: parent.id ?? null,
                        adminModeOrderUser: parent.adminModeOrderUser ?? userId,
                        modules: parent.modules || parent.code,
                        accessLevel:
                            parent.accessLevel ?? (parent.canEdit ? 2 : 1),
                        operations: parent.operations || [],
                    };

                    const childrenPayload = (parent.children || []).map(
                        (child: any) => ({
                            id: child.id ?? null,
                            adminModeOrderUser:
                                child.adminModeOrderUser ?? userId,
                            modules: child.modules || child.code,
                            accessLevel:
                                child.accessLevel ?? (child.canEdit ? 2 : 1),
                            operations: child.operations || [],
                        })
                    );

                    return [parentPayload, ...childrenPayload];
                }
            );

       
            const existingModuleCodes = new Set(
                moduleList.map((m: any) => m.modules)
            );
            const hiddenPayload = (
                (userData.hiddenModules || []) as IBaseModule[]
            )
                .filter((hidden) => !existingModuleCodes.has(hidden.modules))
                .map((hidden) => ({
                    id: null,
                    adminModeOrderUser: userId,
                    modules: hidden.modules,
                    accessLevel: hidden.accessLevel ?? 1,
                    operations: Array.isArray(hidden.operations)
                        ? [...hidden.operations]
                        : [],
                }));

            return {
                user: userId,
                isAggregate: userData.user?.isAggregate ?? false,
                moduleList: [...moduleList, ...hiddenPayload],
            };
        });

        try {
            const response = await fetch(
                "/api/um/admin/mode/order/change-module",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Ошибка обновления: ${response.status} ${response.statusText}`
                );
            }

            await this.getDetailRequest({
                id: this.reqData.order.id as number,
            });

            this.makeToast("success", "Заявка успешно обновлена", "Сохранение");
        } catch (error) {
            console.error(error);
            this.makeToast(
                "danger",
                "Ошибка при обновлении модулей",
                error instanceof Error ? error.message : "Неизвестная ошибка"
            );
        }
    }

    private async sendToSupport(orderId: number): Promise<void> {
        try {
            if (!this.attachedFile) {
                this.makeToast(
                    "warning",
                    "Не прикреплен .pdf файл заявки. Невозможно отправить в ТП. После загрузки файла нажмите кнопку «Сохранить».",
                    "Сообщение",
                    6000
                );
                return;
            }

            if (!orderId) {
                this.makeToast(
                    "danger",
                    "ID заявки не определён. Невозможно отправить в ТП.",
                    "Ошибка"
                );
                return;
            }

            const duplicates: string[] = [];

            for (let i = 0; i < this.reqData.userList.length; i++) {
                const iin = this.reqData.userList[i].user.iin;
                if (!iin) continue;

                const resIin = await fetch(
                    `/api/um/admin/mode/order/check-iin?iin=${iin}&idorder=${orderId}`
                );
                const data: { first: number; second: string } =
                    await resIin.json();

                if (data.first !== 0) {
                    duplicates.push(`${iin}`);
                }
            }

            if (duplicates.length > 0) {
                this.makeToast(
                    "danger",
                    `По данному ИИН зарегистрирована заявка:\n${duplicates.join(
                        "; \n"
                    )}`,
                    "Ошибка"
                );
                return;
            }

            // Если все ИИН уникальны — меняем статус
            const payload = {
                orderid: orderId,
                status: 72,
            };

            const res = await axios.post(
                `api/um/admin/mode/order/change-status`,
                payload
            );

            if (res.status === 200) {
                this.makeToast(
                    "success",
                    "Заявка успешно отправлена в Техническую поддержку",
                    "Сообщение"
                );
                this.isSendToSupport = true;
                await this.getDetailRequest({
                    id: this.reqData.order.id as number,
                });
            } else {
                throw new Error(`Ошибка: ${res.status} - ${res.statusText}`);
            }
        } catch (error) {
            console.error("Ошибка при изменении статуса заявки:", error);
            this.makeToast(
                "danger",
                "Ошибка при изменении статуса заявки",
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    private triggerFileInput() {
        const input = this.$refs.fileInput.$el.querySelector("input");
        if (input) {
            input.click();
        }
    }

    private onFileSelected(event: Event) {
        const target = event.target as HTMLInputElement;
        this.file = target?.files?.[0] || null;
    }
    private isUploadingFile: boolean = false;

    private async uploadFile(orderId: number): Promise<boolean> {
        if (!this.file) {
            this.makeToast("warning", "Файл не выбран!", "Сообщение");
            return false;
        }

        this.isUploadingFile = true;

        try {
            const formData = new FormData();
            formData.append("orderid", orderId.toString());
            formData.append("file", this.file);

            const response = await axios.post(
                "/api/um/admin/mode/order/upload-file",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status === 200) {
                this.makeToast(
                    "success",
                    "Файл успешно загружен",
                    "Загрузка файла"
                );
                return true;
            } else {
                this.makeToast(
                    "danger",
                    "Ошибка при загрузке файла",
                    "Загрузка файла"
                );
                return false;
            }
        } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка при загрузке файла",
                error instanceof Error ? error.message : String(error)
            );
            return false;
        } finally {
            this.isUploadingFile = false;
        }
    }

    private deleteCurFile() {
        this.file = null;
        if (this.attachedFile) {
            this.attachedFile = null;
        }
    }

    private async addNewUser() {
        const deepCopyModules = (modules: IBaseModule[]) => {
            return modules.map((module) => ({
                ...module,
                isModuleDrown: false,
                canEdit: false,
                canAgree: false,
                children: this.getChildModules(module.id).map((child) => ({
                    ...child,
                    canEdit: false,
                    canAgree: false,
                })),
            }));
        };

        // Если в режиме редактирования и шаблон ещё не загружен
        if (
            this.mode === "view" &&
            this.isEditable &&
            !this.isTemplateLoadedOnce
        ) {
            this.isTemplateLoadedOnce = true;
            this.isTemplateLoading = true;
            try {
                await this.selectRequestTemplate();
            } catch (error) {
                console.error("Ошибка при загрузке шаблона:", error);
                this.makeToast(
                    "danger",
                    "Ошибка при загрузке шаблона",
                    error instanceof Error ? error.message : String(error)
                );
                return;
            } finally {
                this.isTemplateLoading = false;
            }
        }

        const newModules = deepCopyModules(this.getParModules);
        // Снимок модулей-сирот текущего шаблона на момент добавления пользователя:
        // они не редактируются в UI, но должны попасть в заявку при сохранении
        // (см. getAllModulesWithDescendants / buildPayload).
        const hiddenModules: IBaseModule[] = JSON.parse(
            JSON.stringify(this.hiddenTemplateModules)
        );

        if (this.mode === "create") {
            this.newUserList.forEach((user) => {
                user.isExpDropdown = false;
            });
            this.newUserList.push({
                iin: "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "+7",
                isAdductor: false,
                modules: newModules,
                hiddenModules,
                isExpDropdown: true,
            });
        } else if (this.mode === "view" && this.isEditable) {
            this.reqData.userList.forEach((u) => {
                u.user.isExpDropdown = false;
            });
            const newUser = {
                user: {
                    id: "0",
                    iin: "",
                    firstname: "",
                    lastname: "",
                    email: "",
                    phone: "+7",
                    check: false,
                    isAggregate: false,
                    isExpDropdown: true,
                },
                moduleList: newModules,
                modulesHierarchy: newModules,
                hiddenModules,
                isExpDropdown: false,
            };

            this.reqData.userList.push(JSON.parse(JSON.stringify(newUser)));
        } else {
            console.warn("Добавление недоступно в текущем режиме");
        }
    }

    private get getParModules(): IBaseModule[] {
        return this.modulesByParentId.get(0) ?? [];
    }

    private getChildModules(parentId: number): IBaseModule[] {
        return this.modulesByParentId.get(parentId) ?? [];
    }

    /**
     * Присваивает modulesList и один раз пересчитывает вспомогательные индексы:
     * - modulesByParentId — группировка по par_id для быстрого getParModules/getChildModules;
     * - hiddenTemplateModules — модули шаблона, чей родитель не входит в шаблон
     *   ("сироты"): они не должны рендериться обычному пользователю, но обязаны
     *   попасть в заявку при сохранении и быть видны/редактируемы техподдержкой.
     *   Приводятся к тому же канонiческому виду (accessLevel/canEdit/canAgree),
     *   что и обычные children и hiddenModules из getDetailRequest — единый
     *   формат читают getAllModulesWithDescendants/updateRequest.
     * Вызывать вместо прямого присвоения this.modulesList = ... .
     */
    private setModulesList(list: IBaseModule[]): void {
        this.modulesList = list;

        const byParentId = new Map<number, IBaseModule[]>();
        const idsInList = new Set<number>();
        for (const module of list) {
            idsInList.add((module as any).id);
        }

        const hidden: IBaseModule[] = [];
        for (const module of list) {
            const parId = (module as any).par_id;
            if (parId !== 0 && !idsInList.has(parId)) {
                // Родитель модуля отсутствует в шаблоне — модуль-сирота:
                // не попадает в индекс по родителям (значит не рендерится
                // обычному пользователю), но сохраняется отдельно, чтобы не
                // потерять его при сохранении. Приводим к канонiческому виду
                // сразу здесь, чтобы downstream-код не знал про access_level.
                const accessLevel = (module as any).access_level ?? 1;
                hidden.push({
                    ...module,
                    code: module.modules,
                    name_ru:
                        this.modulesDict[module.modules] ||
                        module.name_ru ||
                        module.modules,
                    accessLevel,
                    canEdit: accessLevel > 1,
                    canAgree:
                        Array.isArray(module.operations) &&
                        module.operations.length > 0,
                });
                continue;
            }
            const siblings = byParentId.get(parId);
            if (siblings) {
                siblings.push(module);
            } else {
                byParentId.set(parId, [module]);
            }
        }

        this.modulesByParentId = byParentId;
        this.hiddenTemplateModules = hidden;
    }

    hasChildOperations(module: any): boolean {
        if (!Array.isArray(module.children)) return false;
        return module.children.some(
            (child: any) =>
                Array.isArray(child.operations) && child.operations.length > 0
        );
    }

    private selectedModuleOperations: any[] = [];
    private selectedOperationIds: number[] = [];

    private async openOperationsModal(childModule: any) {
        this.selectedModule = childModule;

        this.selectedModuleOperations = [];
        this.selectedOperationIds = [];

        if (this.getOperations) {
            try {
                this.selectedModuleOperations = await this.getOperations(
                    childModule.code
                );
                const savedOps = new Set(
                    (childModule.operations || []).map((o: string) =>
                        o.toLowerCase()
                    )
                );

                this.selectedOperationIds = this.selectedModuleOperations
                    .filter((op) => savedOps.has(op.operation?.toLowerCase()))
                    .map((op) => op.id);
                this.showOperModal = true;
            } catch (e) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки операций",
                    (e as Error).message
                );
            }
        }
    }

    isAgreeOper(operations: string[] | undefined): boolean {
        return (
            Array.isArray(operations) &&
            operations.some((op) => op.includes("agree"))
        );
    }

    isSignOper(operations: string[] | undefined): boolean {
        return (
            Array.isArray(operations) &&
            operations.some((op) => op.includes("sign"))
        );
    }

    private removeUserInput(index: number) {
        if (this.mode === "create") {
            if (index >= 0 && index < this.newUserList.length) {
                this.newUserList.splice(index, 1);
            }
        } else if (this.mode === "view" && this.isEditable) {
            if (
                this.reqData.userList &&
                index >= 0 &&
                index < this.reqData.userList.length
            ) {
                this.reqData.userList.splice(index, 1);
            }
        } else {
            console.warn("Удаление недоступно в текущем режиме");
            return;
        }
        const errorKeys = [
            "iinError",
            "nameError",
            "emailError",
            "phoneError",
        ] as const;

        for (const key of errorKeys) {
            const errorObj = this[key];

            this.$delete(errorObj, index);

            const updatedErrors: Record<number, string | null> = {};
            Object.keys(errorObj).forEach((k) => {
                const num = Number(k);
                if (num > index) {
                    updatedErrors[num - 1] = errorObj[num];
                } else if (num < index) {
                    updatedErrors[num] = errorObj[num];
                }
            });

            this[key] = updatedErrors;
        }
    }

    private toggleDrown(index: number) {
        if (this.mode === "view") {
            this.reqData.userList[index].user.isExpDropdown =
                !this.reqData.userList[index].user.isExpDropdown;
        } else {
            this.newUserList[index].isExpDropdown =
                !this.newUserList[index].isExpDropdown;
        }
    }

    private toggleModuleDrown(module: IBaseModule) {
        if (!module) return;
        this.$set(module, "isModuleDrown", !module.isModuleDrown);
    }

    private removeModule(
        userIndex: number,
        moduleIndex: number,
        childIndex?: number
    ) {
        if (this.mode === "create") {
            this.newUserList[userIndex]?.modules.splice(moduleIndex, 1);
            return;
        }

        if (this.mode !== "view") return;

        const user = this.reqData?.userList?.[userIndex];
        if (!user) return;

        if (this.isUserSupport && this.orderStatus === 73) {
            if (childIndex !== undefined) {
                user.modulesHierarchy?.[moduleIndex]?.children?.splice(
                    childIndex,
                    1
                );
                return;
            }
            user.modulesHierarchy?.splice(moduleIndex, 1);
            user.moduleList?.splice(moduleIndex, 1);
            return;
        }

        // Обычный пользователь удаляет родительские (при статусах =1,27)
        if (!this.isUserSupport && this.isEditable) {
            user.modulesHierarchy?.splice(moduleIndex, 1);
            user.moduleList?.splice(moduleIndex, 1);
        }
    }

    /**
     * Удаляет модуль-сироту (см. hiddenModules/getAllModulesWithDescendants).
     * Отдельная функция, а не переиспользование removeModule: hiddenModules —
     * самостоятельный плоский массив, а не modulesHierarchy/moduleList, и
     * индексируется отдельно. Видно и доступно только техподдержке — обычный
     * пользователь не может вызвать это ни из UI, ни минуя его: без
     * isUserSupport функция ничего не делает.
     */
    private removeHiddenModule(userIndex: number, hiddenIndex: number): void {
        if (!this.isUserSupport) return;

        if (this.mode === "create") {
            this.newUserList[userIndex]?.hiddenModules?.splice(hiddenIndex, 1);
            return;
        }

        if (this.mode !== "view") return;

        this.reqData?.userList?.[userIndex]?.hiddenModules?.splice(
            hiddenIndex,
            1
        );
    }

    private onSelectRow(selectedItem: any) {
        this.requestsList.forEach((item) => {
            this.$set(item, "check", false);
        });

        const found = this.requestsList.find(
            (item) => item.id === selectedItem.id
        );
        if (found) {
            this.$set(found, "check", true);
        }

        this.$emit("select-request", selectedItem);
    }

    private changeTemplate() {
        this.isApplyTemplate = true;
        this.newUserList = [];

        this.selectRequestTemplate();
    }

    private async getGuByCode(code: string) {
        try {
            const res = await fetch(`/api-py/dict-gu-by-code/${code}`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            return data?.[0] ?? null;
        } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка загрузки шаблонов",
                (error as Error).toString()
            );
            return null;
        }
    }

    private async addOtherModules(index: number) {
        let user: any;

        if (this.mode === "create") {
            user = this.newUserList[index];
        } else {
            user = this.reqData.userList[index];
        }

        // Загрузка шаблона при первом вызове (только для сохранённых заявок)
        if (
            this.mode === "view" &&
            this.canEditModules &&
            !this.isTemplateLoadedOnce
        ) {
            this.isTemplateLoadedOnce = true;
            this.isTemplateLoading = true;
            try {
                await this.selectRequestTemplate();
            } catch (error) {
                console.error("Ошибка при загрузке шаблона:", error);
                this.makeToast(
                    "danger",
                    "Ошибка при загрузке шаблона",
                    error instanceof Error ? error.message : String(error)
                );
                return;
            } finally {
                this.isTemplateLoading = false;
            }
        }

        if (!this.modulesList?.length) return;

        const existingCodes =
            this.mode === "create"
                ? user.modules?.map((m: any) => m.code)
                : user.modulesHierarchy?.map((m: any) => m.code);

        const newModules = this.modulesList.filter(
            (tpl) =>
                !existingCodes?.includes(tpl.modules) &&
                tpl.modules.endsWith(".000")
        );

        const newHierarchy = newModules.map((mod) => {
            const prefix = mod.modules.replace(/\.000$/, "");
            const children = this.modulesList
                .filter(
                    (child) =>
                        child.modules.startsWith(prefix) &&
                        child.modules !== mod.modules
                )
                .map((child) => ({
                    ...child,
                    code: child.modules,
                    name_ru: this.modulesDict[child.modules] || child.modules,
                    canEdit: false,
                    canAgree: false,
                }));

            return {
                ...mod,
                code: mod.modules,
                name_ru: this.modulesDict[mod.modules] || mod.modules,
                isModuleDrown: false,
                canEdit: false,
                canAgree: false,
                children,
            };
        });

        if (this.mode === "create") {
            user.modules.push(...newHierarchy);
        } else {
            user.modulesHierarchy?.push(...newHierarchy);
        }
    }

    private async onEditToggle(module: any) {
        if (module.canEdit && !this.modulesList?.length) {
            await this.selectRequestTemplate();
        }

        if (module.canEdit) {
            const templateMatch = this.modulesList?.find(
                (tpl) => tpl.modules === module.modules
            );

            module.accessLevel = templateMatch?.access_level ?? 1;
        } else {
            module.accessLevel = 1;
        }

        if (!Array.isArray(module.children)) return;

        for (const child of module.children) {
            if (module.canEdit) {
                const templateMatch = this.modulesList?.find(
                    (tpl) => tpl.modules === child.modules
                );

                const templateLevel = templateMatch?.access_level ?? 1;

                child.accessLevel = templateLevel;
                child.canEdit = templateLevel > 1;
            } else {
                child.accessLevel = 1;
                child.canEdit = false;
            }
        }
    }

    private async onChildEditToggle(child: any) {
        if (child.canEdit) {
            if (child.accessLevel <= 1) {
                if (!this.modulesList?.length) {
                    await this.selectRequestTemplate();
                }

                const templateMatch = this.modulesList?.find(
                    (tpl) => tpl.modules === child.modules
                );

                child.accessLevel = templateMatch?.access_level ?? 1;
            }
        } else {
            child.accessLevel = 1;
        }
    }

    private async onAgreeToggle(module: any) {
        if (!module.code) return;

        if (module.canAgree && !this.modulesList?.length) {
            await this.selectRequestTemplate();
        }
        this.applyTemplateOperationsToChildren(module);
    }

    private applyTemplateOperationsToChildren(module: any) {
        if (!Array.isArray(module.children)) return;

        for (const child of module.children) {
            child.canAgree = module.canAgree;

            if (!module.canAgree) {
                child.operations = [];
                continue;
            }

            const matchInTemplate = this.modulesList?.find(
                (tpl) => tpl.modules === child.modules
            );

            child.operations =
                matchInTemplate && Array.isArray(matchInTemplate.operations)
                    ? [...matchInTemplate.operations]
                    : [];
        }
    }

    private async selectRequestTemplate() {
        this.isTemplateLoading = true;
        try {
            let typeApp = "";
            let typeOrg = "";
            let query: URLSearchParams | null = null;

            // Режим создания
            if (this.mode === "create") {
                typeApp = String(this.selectedCategApp?.code || "");
                typeOrg = this.typeOrgReq === 0 ? "gu" : "gkkp";

                if (
                    typeApp === "01" &&
                    this.typeOrgReq === 0 &&
                    this.selectedGu?.code
                ) {
                    const guData = await this.getGuByCode(this.selectedGu.code);
                    const orgAttr = guData?.org_attribute ?? 0;
                    const minLevel = guData?.minlevel ?? 0;
                    if (
                        guData?.id_budget_type === "06" &&
                        guData?.abp_owner === "124"
                    ) {
                        typeOrg = "msu";
                    }

                    query = new URLSearchParams({
                        type_app: typeApp,
                        type_org: typeOrg,
                        org_atribute: String(orgAttr),
                        min_level: String(minLevel),
                    });
                } else if (typeApp === "01" && this.typeOrgReq === 1) {
                    query = new URLSearchParams({
                        type_app: typeApp,
                        type_org: typeOrg,
                    });
                } else {
                    query = new URLSearchParams({
                        type_app: typeApp,
                    });
                }

                // Режим редактирования
            } else if (this.mode === "view" && this.canEditModules) {
                typeApp = String(this.reqData?.order?.dictAppTypeAppId || "");
                typeOrg = this.reqData.order.guCode ? "gu" : "gkkp";

                if (typeOrg === "gu" && this.reqData.order.gu) {
                    const guData = await this.getGuByCode(
                        this.reqData.order.guCode
                    );
                    const orgAttr = guData?.org_attribute ?? 0;
                    const minLevel = guData?.minlevel ?? 0;
                    if (
                        guData?.id_budget_type === "06" &&
                        guData?.abp_owner === "124"
                    ) {
                        typeOrg = "msu";
                    }

                    query = new URLSearchParams({
                        type_app: typeApp,
                        type_org: typeOrg,
                        org_atribute: String(orgAttr),
                        min_level: String(minLevel),
                    });
                } else {
                    query = new URLSearchParams({
                        type_app: typeApp,
                        type_org: typeOrg,
                    });
                }
            }

            if (!query) {
                this.makeToast(
                    "danger",
                    "Недостаточно данных для загрузки шаблона",
                    "Сообщение"
                );
                return;
            }

            const res = await fetch(
                `/api/um/admin/mode/template-id?${query.toString()}`
            );
            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const text = await res.text();
            if (!text) {
                this.makeToast("warning", "Шаблон не найден!", "Сообщение");
                this.setModulesList([]);
                this.canAddUser = false;
                return;
            }

            let templateId: number | null = null;
            try {
                templateId = JSON.parse(text);
            } catch {
                this.makeToast(
                    "warning",
                    "Нет соответствующего шаблона",
                    "Сообщение"
                );
                this.setModulesList([]);
                this.canAddUser = false;
                return;
            }

            if (!templateId) {
                this.makeToast(
                    "warning",
                    "Нет соответствующего шаблона",
                    "Сообщение"
                );
                this.setModulesList([]);
                this.canAddUser = false;
                return;
            }

            const response = await axios.get(
                `/api/um/admin/mode/template-elements?idtemplate=${templateId}`
            );
            const templateDetails: ITemplateDetail = response.data;

            this.setModulesList(
                templateDetails.elements.map((el) => {
                    const base = this.modulesBase.find(
                        (b) => b.code === el.modules
                    );
                    return {
                        ...base,
                        access_level: el.accessLevel,
                        operations: el.operations,
                        modules: el.modules,
                        isModuleDrown: false,
                        isUsersModuleDrown: false,
                    } as IBaseModule;
                })
            );
            this.canAddUser = true;
        } catch (error) {
            this.canAddUser = false;
            this.makeToast(
                "danger",
                "Ошибка загрузки шаблонов",
                (error as Error).message
            );
        } finally {
            this.isTemplateLoading = false;
        }
    }

    private groupModOper(
        operations: any[]
    ): Record<string, { title: string; items: any[] }> {
        const groups: Record<string, { title: string; items: any[] }> = {
            "01": { title: "Согласование", items: [] },
            "02": { title: "Подписание", items: [] },
            "03": { title: "Отчеты", items: [] },
            "04": { title: "Другое", items: [] },
        };
        operations.forEach((op) => {
            if (groups[op.code]) {
                groups[op.code].items.push(op);
            } else {
                groups["04"].items.push(op);
            }
        });
        // Удаление групп без элементов
        Object.keys(groups).forEach((key) => {
            if (groups[key].items.length === 0) {
                delete groups[key];
            }
        });

        return groups;
    }

    private async takeReqInWork(orderId: number) {
        try {
            const payload = {
                orderid: orderId,
                status: 73,
            };

            const responseStatus = await axios.post(
                `api/um/admin/mode/order/change-status`,
                payload
            );

            if (responseStatus.status === 200) {
                this.makeToast("success", "Заявка взята в работу", "Сообщение");
                this.reqData.order.status = 73;
                this.isReqCancelled = false;
                this.isReqReturned = false;
                await this.getDetailRequest({
                    id: this.reqData.order.id as number,
                });
            } else {
                throw new Error(
                    `Ошибка: ${responseStatus.status} - ${responseStatus.statusText}`
                );
            }
        } catch (error) {
            console.error("Ошибка при изменении статуса заявки:", error);
            this.makeToast(
                "danger",
                "Ошибка при изменении статуса заявки",
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    private currentUmUser: any = null;

    private async openUmForm(item: any) {
        this.currentUmUser = item.userId;
        this.curUserIin = item.iin;

        this.clearUmLists();

        await this.loadAllUmData(this.currentUmUser);

        this.activeMenu = this.availableMenus[0]?.key ?? "";

        this.showUmForm = true;
        this.showRequestForm = false;
    }

    private handleUmClick(item: any) {
        if (this.isUserSupport && this.reqData.order.status === 74) {
            this.openUmForm(item);
        }
    }

    private openComModal(orderId: number) {
        this.commentTxt = "";
        this.showComModal = true;
        this.selectedReasonIds = [];
        this.loadReasonsList();
    }

    private async loadReasonsList() {
        try {
            const response = await fetch("/api/dict/type_return_order");
            this.reasonsList = await response.json();
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса причин возврата на доработок",
                    error.toString()
                );
            }
        }
    }

    private async loadCommentsHistory(idorder: number) {
        try {
            const response = await fetch(
                `api/um/admin/mode/order/return-reason?idorder=${idorder}`
            );

            if (!response.ok) {
                throw new Error(`Ошибка HTTP: ${response.status}`);
            }

            const text = await response.text();

            if (!text || text.trim() === "") {
                this.commentHistoryList = [];
                return;
            }

            const data = JSON.parse(text);
            this.commentHistoryList = Array.isArray(data) ? data : [];
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса комментариев",
                    error.toString()
                );
                this.commentHistoryList = [];
            }
        }
    }

    private async loadStatusHistory(idorder: number) {
        try {
            const response = await fetch(
                `api/um/admin/mode/order/return-status-history?idorder=${idorder}`
            );

            if (!response.ok) {
                throw new Error(`Ошибка HTTP: ${response.status}`);
            }

            const statusData = await response.text();

            if (!statusData || statusData.trim() === "") {
                this.statusHistoryList = [];
                return;
            }

            const data = JSON.parse(statusData);
            this.statusHistoryList = Array.isArray(data)
                ? data.map((item: { status: number; dt: number | null }) => ({
                      ...item,
                      statusName: this.getProjectStatusLabel(item.status),
                  }))
                : [];
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса статусов заявки",
                    error.toString()
                );
                this.statusHistoryList = [];
            }
        }
    }

    private async returnReqForRevision(orderId: number) {
        try {
            const returnReasons = this.selectedReasonIds.map((id) => {
                const reasonObj: { type: number; reason?: string } = {
                    type: id,
                };

                if (id === 4 && this.commentTxt && this.commentTxt.trim()) {
                    reasonObj.reason = this.commentTxt.trim();
                }

                return reasonObj;
            });

            const payload = {
                orderid: orderId,
                status: 27,
                return_reasons: returnReasons,
            };

            const responseStatus = await axios.post(
                `api/um/admin/mode/order/change-status`,
                payload
            );

            if (responseStatus.status === 200) {
                this.makeToast(
                    "success",
                    "Заявка возвращена на доработку",
                    "Сообщение"
                );
                this.showComModal = false;
                this.reqData.order.status = 27;

                await this.getDetailRequest({
                    id: this.reqData.order.id as number,
                });
            } else {
                throw new Error(
                    `Ошибка: ${responseStatus.status} - ${responseStatus.statusText}`
                );
            }
        } catch (error) {
            console.error("Ошибка при изменении статуса заявки:", error);
            this.makeToast(
                "danger",
                "Ошибка при изменении статуса заявки",
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    private async markReqAsProcessed(orderId: number) {
        try {
            const usersCreated = await this.createKeycloakUsers(orderId);

            if (!usersCreated) {
                return;
            }

            const payload = {
                orderid: orderId,
                status: 74,
            };

            const responseStatus = await axios.post(
                `api/um/admin/mode/order/change-status`,
                payload
            );

            if (responseStatus.status === 200) {
                this.makeToast(
                    "success",
                    "Заявка успешно обработана",
                    "Сообщение"
                );

                await this.getDetailRequest({
                    id: this.reqData.order.id as number,
                });
            } else {
                throw new Error(
                    `Ошибка: ${responseStatus.status} - ${responseStatus.statusText}`
                );
            }
        } catch (error) {
            console.error("Ошибка при изменении статуса заявки:", error);
            this.makeToast(
                "danger",
                "Ошибка при изменении статуса заявки",
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    private async createKeycloakUsers(orderId: number): Promise<boolean> {
        try {
            const response = await axios.post(
                `/api/um/admin/mode/order/process`,
                null,
                {
                    params: {
                        orderid: orderId,
                    },
                }
            );

            if (response.status === 200) {
                this.makeToast(
                    "success",
                    "Пользователи успешно созданы в базе данных",
                    "Сообщение"
                );
                return true;
            }
            return false;
        } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка при создании учеток в Keycloak",
                error instanceof Error ? error.message : String(error)
            );
            return false;
        }
    }

    private async getServerRegList() {
        try {
            const response = await axios.get("api/um/admin/mode/order/regions");

            const regions = response.data;

            const allRegion = {
                id: 0,
                code: "all",
                nameRu: "Все регионы",
                nameKk: "Барлық аймақтар",
            };

            this.serverRegList = [allRegion, ...regions];
            this.selectedRegServer = this.serverRegList[0];
        } catch (error) {
            console.error("Ошибка при получении списка регионов:", error);
            this.makeToast(
                "danger",
                "Ошибка при получении списка регионов",
                error instanceof Error ? error.message : String(error)
            );
        }
    }
    get regionName(): string {
        if (!this.reqData?.order?.region || !this.serverRegList.length) {
            return "";
        }

        const region = this.serverRegList.find(
            (r: any) => r.code === this.reqData.order.region
        );

        return region ? region.nameRu : this.reqData.order.region;
    }

    get canSave(): boolean {
        if (!this.showRequestForm) return false;

        if (this.mode === "create") {
            return !this.isSavedReq;
        }

        if (this.mode === "view") {
            const status = this.reqData?.order?.status;

            if (!this.isUserSupport) {
                return status === 1 || status === 27;
            }

            if (this.isUserSupport) {
                return status === 73;
            }
        }

        return false;
    }

    get canEditChildModules(): boolean {
        return (
            this.mode === "view" &&
            this.isUserSupport &&
            this.orderStatus === 73
        );
    }

    private async openAddModChildForm(userIndex: number, modIndex: number) {
        const user = this.reqData.userList[userIndex];
        const module = user.modulesHierarchy?.[modIndex];
        if (!module) return;
        this.selectedModule = module;

        this.selectedUserIndex = userIndex;
        this.selectedModIndex = modIndex;

        this.selectedModChildItems = [];
        this.selectAllModChild = false;

        this.addOtherModChild(userIndex, modIndex);

        this.showAddModChildForm = true;
    }

    private async markModulesHasOperations() {
        const users = this.reqData.userList;

        const allChildren: any[] = [];

        users.forEach((user: any) => {
            user.modulesHierarchy?.forEach((parent: any) => {
                parent.children?.forEach((child: any) => {
                    allChildren.push(child);
                });
            });
            // Модули-сироты видны и редактируемы только техподдержкой (см.
            // блок "Прочие модули" в шаблоне), но индикатор наличия операций
            // в модалке согласования им нужен так же, как обычным children.
            user.hiddenModules?.forEach((hidden: any) => {
                allChildren.push(hidden);
            });
        });

        await Promise.all(
            allChildren.map(async (child: any) => {
                const hasSelected =
                    Array.isArray(child.operations) &&
                    child.operations.length > 0;

                if (hasSelected) {
                    child.hasOperations = true;
                    return;
                }

                try {
                    const ops = await this.getOperations(child.code);

                    child.hasOperations = Array.isArray(ops) && ops.length > 0;
                } catch (e) {
                    console.warn(`Ошибка проверки операций ${child.code}`, e);
                    child.hasOperations = false;
                }
            })
        );
    }

    private async addOtherModChild(userIndex: number, modIndex: number) {
        const user = this.reqData.userList[userIndex];
        const module = user.modulesHierarchy?.[modIndex];
        if (!module || !this.modulesBase?.length) return;

        const prefix = module.code.replace(/\.000$/, "");
        const existingChildCodes =
            module.children?.map((c: any) => c.code) || [];

        this.moduleChildList = this.modulesBase
            .filter((item: any) => {
                if (!item.code) return false;

                const isChildOfModule =
                    item.code.startsWith(prefix) && item.code !== module.code;

                const notAdded = !existingChildCodes.includes(item.code);

                const isActive = item.status === "ACTIVE";

                return isChildOfModule && notAdded && isActive;
            })
            .map((child: any) => ({
                ...child,
                canEdit: false,
                canAgree: false,
                operations: [],
                hasOperations: false,
            }));

        if (this.getOperations) {
            await Promise.all(
                this.moduleChildList.map(async (child: any) => {
                    try {
                        const ops = await this.getOperations(child.code);
                        if (Array.isArray(ops) && ops.length > 0) {
                            child.hasOperations = true;
                        }
                    } catch (e) {
                        console.warn(
                            `Ошибка загрузки операций для ${child.code}`,
                            e
                        );
                    }
                })
            );
        }
    }

    private resetCheckModChild(): void {
        this.selectedModChildItems = [];
        this.selectAllModChild = false;
        this.searchModChild = "";
        this.showAddModChildForm = false;
    }

    private toggleSelectAll() {
        if (this.selectAllModChild) {
            this.selectedModChildItems = this.filteredModChildren.map(
                (item) => item.code
            );
        } else {
            this.selectedModChildItems = [];
        }
        this.moduleChildList.forEach((child) => {
            child.check = this.selectedModChildItems.includes(child.code);
        });
    }

    get filteredModChildren(): any[] {
        if (!this.searchModChild) {
            return this.moduleChildList;
        } else {
            const query = this.searchModChild.toLowerCase();
            return this.moduleChildList.filter((item) => {
                return (
                    item.code.toString().toLowerCase().includes(query) ||
                    item.name_ru.toLowerCase().includes(query)
                );
            });
        }
    }

    private updateSelectAll() {
        this.moduleChildList.forEach((module) => {
            module.check = this.selectedModChildItems.includes(module.code);
        });

        this.selectAllModChild =
            this.filteredModChildren.length > 0 &&
            this.filteredModChildren.every((module) =>
                this.selectedModChildItems.includes(module.code)
            );
    }

    private handleAddChild() {
        const user = this.reqData.userList[this.selectedUserIndex];

        const module = user.modulesHierarchy?.[this.selectedModIndex];

        if (!module) return;

        const selectedChildren = this.moduleChildList.filter((item: any) =>
            this.selectedModChildItems.includes(item.code)
        );

        module.children.push(...selectedChildren);

        this.showAddModChildForm = false;
        this.resetCheckModChild();
    }

    private isGroupSelected(groupItems: any[]) {
        if (!groupItems.length) return false;

        return groupItems.every((op) =>
            this.selectedOperationIds.includes(op.id)
        );
    }

    private onGroupChange(items: any[], checked: boolean) {
        this.toggleGroup(items, checked);

        this.$nextTick(() => {
            this.onOperationsChange();
        });
    }

    private toggleGroup(groupItems: any[], checked: boolean) {
        const ids = groupItems.map((op) => op.id);

        if (checked) {
            this.selectedOperationIds = Array.from(
                new Set([...this.selectedOperationIds, ...ids])
            );
        } else {
            this.selectedOperationIds = this.selectedOperationIds.filter(
                (id) => !ids.includes(id)
            );
        }
    }

    private syncParentAgree(childModule: any) {
        const parent = this.getParModules.find(
            (p) => p.id === childModule.par_id
        );

        if (!parent) return;

        const children = this.getChildModules(parent.id);

        parent.canAgree = children.some(
            (c) => Array.isArray(c.operations) && c.operations.length > 0
        );
    }

    private onOperationsChange() {
        if (!this.selectedModule) return;

        this.$nextTick(() => {
            const selected = this.selectedModuleOperations.filter((op) =>
                this.selectedOperationIds.includes(op.id)
            );

            this.selectedModule.operations = selected.map((op) => op.operation);
            this.selectedModule.canAgree = selected.length > 0;

            this.syncParentAgree(this.selectedModule);
        });
    }

    private async onAllOperChange(checked: boolean, child: any) {
        if (!this.selectedModule || this.selectedModule.code !== child.code) {
            this.selectedModule = child;

            try {
                this.selectedModuleOperations = this.getOperations
                    ? await this.getOperations(child.code)
                    : [];
            } catch (e) {
                this.selectedModuleOperations = [];
            }

            this.selectedOperationIds = this.selectedModuleOperations
                .filter((op) => child.operations?.includes(op.operation))
                .map((op) => op.id);
        }

        if (checked) {
            this.selectedOperationIds = this.selectedModuleOperations.map(
                (op) => op.id
            );
        } else {
            this.selectedOperationIds = [];
        }

        this.onOperationsChange();
    }

    private async getAllFgrList(): Promise<any[]> {
        try {
            const response = await axios.get(
                "api-py/get-dict-func-childs-by-parent/0"
            );
            const allData = response.data;
            return allData;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса списка функциональных групп",
                    error.message
                );
            }
            return [];
        }
    }

    private async getFgrList(baseFgrList: any[], userId: string) {
        try {
            const res = await axios.get(`/api-py/user-fgr/${userId}`);
            const userFgr = res.data;

            const userGroups = new Set(userFgr.map((item: any) => item.fgr));

            this.fgrList = baseFgrList
                .filter((item) => userGroups.has(item.gr))
                .map((item) => ({
                    code: item.gr,
                    name:
                        this.curLanguage === "kk" ? item.name_kk : item.name_ru,
                }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных функциональных групп",
                    error.message
                );
            }
        }
    }

    private async getAllCategory(): Promise<any[]> {
        try {
            const response = await fetch(
                "/api-py/get-dict-doh-childs-by-parent/0"
            );
            const data = await response.json();
            return data;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса списка категорий доходов",
                    error.message
                );
            }
            return [];
        }
    }

    private async getCategList(baseCategList: any[], userId: string) {
        try {
            const response = await fetch("/api-py/user-kat/" + userId);
            const categData = await response.json();

            const userCateg = new Set(categData.map((item: any) => item.kat));

            this.categUmList = baseCategList
                .filter((item) => userCateg.has(item.kat))
                .map((item) => ({
                    code: item.kat,
                    name:
                        this.curLanguage === "kk" ? item.name_kk : item.name_ru,
                }));
            this.categUmList.sort((a, b) => a.code - b.code);
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных категорий доходов",
                    error.message
                );
            }
        }
    }

    private async getAbpList(userId: string) {
        try {
            const res = await axios.get(
                `/api-py/get-selected-user-abp/${userId}`
            );
            this.abpUmList = res.data.map((item: any) => ({
                code: item.abp,
                name: this.curLanguage === "kk" ? item.name_kk : item.name_ru,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных АБП",
                    error.message
                );
            }
        }
    }

    private oblKato: any = null;

    async fetchObl() {
        try {
            await fetch(
                "/api-py/get-budget-obl/" + this.$store.state._instanceCode
            )
                .then((response) => response.json())
                .then((json) => {
                    this.oblKato = json.obl;
                });
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.region_code_req_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    private async getAllRegions() {
        await this.fetchObl();

        const response = await fetch(
            "/api-py/get-regions-by-obl/" + this.oblKato
        );

        return await response.json();
    }

    private async getRegionList(userId: string) {
        try {
            this.regUmList = [];

            const response = await fetch("/api-py/user-region/" + userId);
            const userRegions = await response.json();

            const allRegions = await this.getAllRegions();

            for (const userRegion of userRegions) {
                const foundRegion = allRegions.find(
                    (region: any) => region.code === userRegion.region
                );
                if (foundRegion) {
                    this.regUmList.push({
                        code: foundRegion.code,
                        name: foundRegion.name_ru,
                    });
                }
            }
            this.regUmList.sort((a, b) => a.code - b.code);
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных регионов",
                    error.message
                );
            }
        }
    }

    private async getMsuList(userId: string) {
        try {
            const res = await fetch(`api-py/get-user-msu/${userId}`);
            const userMsu = await res.json();

            this.msuUmList = userMsu.map((item: any) => ({
                code: item.region,
                name: "",
                loaded: false,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных МСУ",
                    error.message
                );
            }
        }
    }

    private async getRegName(region: string): Promise<string> {
        const start = performance.now();
        if (this.regNameCache.has(region)) {
            const cachedName = this.regNameCache.get(region)!;
            return cachedName;
        }

        try {
            const res = await fetch(`/api-py/dict-region-by-code/${region}`);
            const data = await res.json();
            const regCode = Array.isArray(data)
                ? data.find((item: any) => item.code === region)
                : data;

            const name = regCode ? regCode.name_ru : "МСУ не найден";
            this.regNameCache.set(region, name);
            return name;
        } catch (error) {
            console.error(`Ошибка получения данных МСУ ${region}:`, error);
            this.regNameCache.set(region, "Ошибка получения данных МСУ");
            return "Ошибка получения данных МСУ";
        }
    }

    private async getGuList(userId: string) {
        try {
            const res = await axios.get(`/api-py/dict-user-gu-names/${userId}`);
            this.guUmList = res.data.map((item: any) => ({
                code: item.code,
                name: this.curLanguage === "kk" ? item.name_kk : item.name_ru,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных ГУ",
                    error.message
                );
            }
        }
    }

    private async loadNames<
        T extends { code: string; name: string; loaded?: boolean }
    >(list: T[], getName: (code: string) => Promise<string>): Promise<void> {
        await Promise.all(
            list.map(async (item) => {
                if (item.loaded) {
                    return;
                }

                item.name = await getName(item.code);
                item.loaded = true;
            })
        );
    }

    private async getGkkpList(userId: string) {
        try {
            const res = await fetch(`api-py/user-kgkp/${userId}`);
            const gkkpData = await res.json();

            this.gkkpUmList = gkkpData.map((item: any) => ({
                code: item.kgkp,
                name: "",
                loaded: false,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных ГККП",
                    error.message
                );
            }
        }
    }

    private operationDict: Record<string, string> = {};

    private async loadOperationDict(): Promise<void> {
        const { data } = await axios.get("/api-py/dict-user-orerations");

        this.operationDict = {};

        data.forEach((item: any) => {
            this.operationDict[item.code] = item.name_ru;
        });
    }

    private async getModuleList(userId: string) {
        try {
            if (!Object.keys(this.modulesDict).length) {
                await this.loadAndCacheModules();
            }

            if (!Object.keys(this.operationDict).length) {
                await this.loadOperationDict();
            }

            const res = await axios.get(`/api-py/user-modules/${userId}`);

            this.moduleUmList = res.data.map((item: any) => ({
                code: item.modules,
                name: this.modulesDict[item.modules] ?? item.modules,
                access_level: item.access_level,
                operationNames: (item.operations || []).map(
                    (code: string) => this.operationDict[code] ?? code
                ),
            }));

            this.moduleUmList.sort((a, b) => a.code.localeCompare(b.code));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных модулей",
                    error.message
                );
            }
        }
    }

    private async getUmGuWorkplace(userId: string) {
        try {
            const response = await fetch(`api-py/user-workplace-gu/${userId}`);
            const wpData = await response.json();

            this.workGuUmList = wpData.map((item: any) => ({
                code: item.workplace,
                isAgregate: item.lead,
                name: "",
                loaded: false,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса место работы ГУ",
                    error.message
                );
            }
        }
    }

    private async getUmGkkpWorkplace(userId: string) {
        try {
            const response = await fetch(
                `api-py/user-workplace-kgkp/${userId}`
            );
            const wpData = await response.json();

            this.workGkkpUmList = wpData.map((item: any) => ({
                code: item.workplace,
                name: "",
                loaded: false,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса место работы ГККП",
                    error.message
                );
            }
        }
    }

    makeToast(
        variant: string | undefined,
        tostbody: any,
        title: string,
        delay: number = 3000
    ) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: delay,
            solid: true,
            appendToast: true,
        });
    }
}
